/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * @title Commerce Cloud Platform
 * @version 1.0.0
 * @baseUrl https://ccp-api-gateway.prod.atl-paas.net
 * @externalDocs https://developer.atlassian.com/platform/commerce-cloud-platform/security/authentication/
 * @contact CCP Developers (https://atlassian.slack.com/archives/C016U73MTC1)
 *
 * Commerce Cloud Platform (CCP) is a part of Project Tintin (go/tintin). Tintin is the foundational initiative unifying Pricing, Product Catalog, Subscriptions and Billing engines across all our Cloud products, to unleash Atlassian’s ability to scale to a $10B company.
 */

import type { ExceptionResult, Result } from "resultful";
import { error, exception, isFailure, isSuccess, success } from "resultful";

/**
 * The response from the client was not defined in the schema.
 * This doesn't necessarily mean that the fetch failed to perform its intended behaviour - It's just that the response
 * was not defined in the schema. You may want to wrap the fetch calls provided by this client with your own logic that
 * handles certain error codes as success regardless of whether it's defined in the schema or not.
 */
const NOT_IN_SCHEMA = "not-in-schema";

/**
 * This error is reported when the schema does not list any mime types that we support in this client.
 */
const MIME_TYPE_NOT_SUPPORTED = "mime-type-not-supported";

type ErrorCodes = typeof NOT_IN_SCHEMA | typeof MIME_TYPE_NOT_SUPPORTED;
const getValidResponseOrThrow = <Response>(result: Result<Response, unknown, unknown>): Response => {
  if (!isSuccess(result)) {
    if (result.error) {
      // eslint-disable-next-line no-console
      console.log(result.error);
    }
    if (result.exception) {
      // eslint-disable-next-line no-console
      console.error(result.exception);
    }
    throw new Error(`getValidResponseOrThrow: request failed: ${String(result.error ?? result.exception)}`);
  }

  return result.payload;
};

type HttpSuccess = 200 | 201 | 202 | 203 | 204 | 205 | 206;

/**
 * Extract the type of the body key from responses with a 2xx status code
 */
export type SuccessBodyType<Response> = Response extends { status: number }
  ? number extends Response["status"]
    ? unknown
    : Response extends { status: HttpSuccess; body: infer Body }
    ? Body
    : never
  : Response extends unknown
  ? unknown
  : never;

/**
 * Extract the type of the body key from responses with a non 2xx status code
 */
type FailureBodyType<Response> = Response extends { status: number }
  ? number extends Response["status"]
    ? unknown
    : Response extends { status: number; body: unknown }
    ? Exclude<Response["body"], SuccessBodyType<Response>>
    : Response extends unknown
    ? unknown
    : never
  : unknown;

export const getSuccessfulResultOrThrow = <
  Return extends { status: number; body: unknown; response?: { url?: string } },
>(
  result: Result<Return, unknown, unknown>,
): SuccessBodyType<Return> => {
  const response = getValidResponseOrThrow(result);

  if (response.status < 200 || response.status >= 300) {
    // eslint-disable-next-line no-console
    console.log(`getSuccessfulResultOrThrow: Response: ${response}`);
    throw new Error(`getSuccessfulResultOrThrow: Status code: ${response.status} ${response.response?.url ?? ""}`);
  }

  return response.body as SuccessBodyType<Return>;
};

/**
 * Automatically handle failed requests or responses by throwing an exception
 */
export const assumeSuccessfulResult =
  <Params extends unknown[], Return extends { status: number; body: unknown }>(
    endpoint: (...args: Params) => Promise<Result<Return, unknown, unknown>>,
  ) =>
  async (...args: Params): Promise<SuccessBodyType<Return>> =>
    getSuccessfulResultOrThrow(await endpoint(...args));
type ResponseDetailsCommon = {
  status: number;
  statusText: string;
  response: Response;
};

/**
 * A valid response according to the schema
 */
type ResponseDetailsSuccess<ApiResponse extends { status: number }> = ResponseDetailsCommon & {
  type: "success";
  status: HttpSuccess & ApiResponse["status"];
  body: SuccessBodyType<ApiResponse>;
  response: Omit<Response, "status"> & {
    status: HttpSuccess & ApiResponse["status"];
  };
};

type ResponseDetailsFailure<ApiResponse extends { status: number }> = ResponseDetailsCommon & {
  type: "failure";
  status: Omit<ApiResponse["status"], HttpSuccess>;
  body: FailureBodyType<ApiResponse>;
  response: Omit<Response, "status"> & {
    status: Exclude<ApiResponse["status"], HttpSuccess>;
  };
};

/**
 * A response that is not valid according to the schema
 */
type ResponseDetailsInvalid = ResponseDetailsCommon & {
  type: "invalid";
  code: ErrorCodes;
};

type ResponseDetails<ApiResponse extends { status: number }> =
  | ResponseDetailsSuccess<ApiResponse>
  | ResponseDetailsFailure<ApiResponse>
  | ResponseDetailsInvalid;

/**
 * Function returning a series of hooks/callbacks to be called at different
 * times in the lifecycle of a particular request
 */
export type RequestHooks<
  ApiResponse extends { status: number; response: Response; body: unknown } = {
    status: number;
    response: Response;
    body: unknown;
  },
  PathParams extends Record<string, unknown> | undefined = Record<string, unknown> | undefined,
  QueryParams extends Record<string, unknown> | undefined = Record<string, unknown> | undefined,
  Body extends Record<string, any> | undefined = Record<string, any> | undefined,
  Headers extends Record<string, unknown> | undefined = Record<string, unknown> | undefined,
> = (requestInfo: {
  /**
   * Information about the global request configuration
   */
  configuration: {
    baseGatewayUrl: string;
  };
  /**
   * Information about the endpoint being called according to the schema
   */
  schema: {
    path: string;
    method: HttpMethod;
    operationId: string | null;
    summary: string | null;
    methodName: string;
  };
  /**
   * Information about the specific request being made
   */
  data: {
    pathParameters: PathParams;
    queryParameters: QueryParams;
    body: Body;
    headers: Headers;
  };
}) => MaybePromise<{
  /**
   * Called immediately before a request is made
   */
  request?: () => MaybePromise<void>;
  /**
   * Called immediately after a response is received
   */
  response?: (responseDetails: ResponseDetails<ApiResponse>) => MaybePromise<void>;
  /**
   * Called when there is an error and a response was not received
   */
  error?: ({ exception }: { exception: Error }) => MaybePromise<void>;
}>;
type NotInSchemaErrorPayload = Readonly<{
  code: typeof NOT_IN_SCHEMA;
  response: Response;
  status: number;
}>;

type MimeTypeNotSupportedErrorPayload = Readonly<{
  code: typeof MIME_TYPE_NOT_SUPPORTED;
  response: Response;
  status: number;
}>;

export type FetchErrorPayload = NotInSchemaErrorPayload | MimeTypeNotSupportedErrorPayload;
export const wrapInTryCatch = <ArgsGeneric extends any[], ReturnGeneric>(
  handler: (...args: ArgsGeneric) => Promise<ReturnGeneric>,
): ((...args: ArgsGeneric) => Promise<ReturnGeneric | ExceptionResult<unknown>>) => {
  return async (...args: ArgsGeneric) => {
    try {
      return await handler(...args);
    } catch (err) {
      // TODO: Remove once AFP supports TypeScript 4
      return exception(err as unknown);
    }
  };
};

export type FetchInterface = (
  url: string,
  options?: {
    headers?: Record<string, string>;
    body?: string;
    method?: string;
  },
) => Promise<Response>;

const flatten = (params?: Record<string | number, unknown> | null): Record<string | number, unknown> => {
  const result: Record<string | number, unknown> = {};
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (typeof value === "object") {
      Object.assign(result, flatten(value as Record<string | number, unknown>));
      return;
    }
    result[key] = value;
  });
  return result;
};

const FAKE_ORIGIN = "http://FAKE_ORIGIN";

/**
 * Determine if the given URL is a full URL (including the origin),
 * or if it it just a path
 */
const isFullUrl = (url: string) => new URL(url, FAKE_ORIGIN).href === url;

/**
 * Construct a URL for an API endpoint
 * @param endpointPath The path of the endpoint within the API (with a trailing slash)
 * @param baseGatewayUrl The base URL of the API
 * @param queryParameters The path parameters
 */
export const constructUrl = (
  endpointPath: string,
  baseGatewayUrl: string,
  queryParameters: Record<string, unknown> = {},
) => {
  // The WHATWG URL API does not work with relative paths, hence FAKE_ORIGIN.
  // See: https://github.com/whatwg/url/issues/531
  const fakeUrl = new URL(endpointPath, isFullUrl(baseGatewayUrl) ? baseGatewayUrl : FAKE_ORIGIN);
  // TODO: find out how undefined, arrays, and objects should be encoded
  fakeUrl.search = new URLSearchParams(flatten(queryParameters) as Record<string, string>).toString();
  return isFullUrl(baseGatewayUrl) ? fakeUrl.href : `${baseGatewayUrl}${fakeUrl.href.slice(FAKE_ORIGIN.length + 1)}`;
};
export type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

export type MaybePromise<T> = Promise<T> | T;

import type {
  AcceptQuoteRequest,
  AcceptQuoteResponse,
  ActivePricingPlanCountResponse,
  AddUserDefinedNotePayload,
  AdhocInvoice,
  AdhocInvoiceCreationInput,
  ApiError,
  ApiGatewayErrorResponse,
  ApplicablePromotionCodesRequest,
  ApplicablePromotionCodesResponse,
  ApplicablePromotionRequestV2,
  ApplicablePromotionResponse,
  ArchivedObjectConfiguration,
  ArchivedObjectDto,
  AvailablePromotionRequest,
  AvailablePromotionResponse,
  BaseResponse,
  BillEstimateResponse,
  BillingClockRequest,
  BillingClockResponseDto,
  BillToParty,
  BillToPartyInput,
  CancelQuoteRequest,
  CancelQuoteResponse,
  CatalogAccountResponse,
  CloneQuoteRequest,
  CloneQuoteResponse,
  CountQueryRequest,
  CountQueryResponse,
  CreateCreditNotePayload,
  CreateEntityIgnoreRuleRequest,
  CreateInvoiceGroupInput,
  CreateOfferingChangeRequest,
  CreateOfferingRelationshipTemplateRequest,
  CreateProductIgnoreRuleResponse,
  CreatePromotionCodesRequest,
  CreatePromotionRequestV2,
  CreatePromotionResponseV2,
  CreateQuoteRequest,
  CreateQuoteResponse,
  CreateRandomPromotionCodesRequest,
  CreditNoteDto,
  CustomerBalanceDto,
  CustomerBalanceTransactionListDto,
  DeletePaymentMethodInput,
  DeleteProductIgnoreRuleResponse,
  DeleteRoleInput,
  DependsOnOfferingInput,
  DunningAttemptInput,
  EntitlementDetails,
  EntitlementErrorResponse,
  EntitlementResponse,
  EntitlementSlugValidateResponse,
  EntitlementSummary,
  EntitlementTemplateInput,
  EntitlementTemplateResponse,
  EntitlementTemplateUpdateInput,
  EntitlementTemplateV2Response,
  EntitlementTransitionResponse,
  EntitlementTraversalRequestDto,
  EntitlementTraversalResponseDto,
  EntityExtensionDataResponse,
  ErrorResponse,
  EstimateTaxDto,
  EstimateTaxInput,
  ExampleFileUploadRequest,
  FinalizeQuoteRequest,
  FinalizeQuoteResponse,
  GenericPaginatedResponse,
  GetProductIgnoreRuleResponse,
  GetPromotionByIdResponseV2,
  GetPromotionCodeResponse,
  GetQuoteResponse,
  GetRedemptionsResponse,
  InvoiceDto,
  InvoiceGroupDto,
  InvoiceGroupStatus,
  InvoiceRequest,
  InvoiceRequestInput,
  InvoiceRequestListDto,
  JsonPatch,
  MarkDraftQuoteRequest,
  MarkDraftQuoteResponse,
  MigratePaymentMethodInput,
  OfferingChangeResponse,
  OfferingChangeUpdateInput,
  OfferingDetailsResponse,
  OfferingErrorResponse,
  OfferingInput,
  OfferingPatchUpdateInput,
  OfferingRelationshipResponse,
  OfferingRelationshipTemplateResponse,
  OfferingSlugsInput,
  OfferingUpdateInput,
  OfferingV2Response,
  OrderBillEstimateResponseDto,
  OrderDefault,
  OrderGetResponseDto,
  OrderIntentGetResponseDto,
  OrderIntentResponseDto,
  OrderIntentWithOrderItemsLegacyWebRequestDto,
  OrderResponseDto,
  OrderServiceValidationErrorResponse,
  PagedListArchivedObjectDto,
  PagedListAuditLogDto,
  PagedListInvoiceDto,
  PagedListInvoiceGroupDto,
  PagedListPaymentMethodDto,
  PagedListShipToPartyDto,
  PageRequest,
  PageResponsePromotionCodeResponse,
  PaginatedOrderItemResponseDto,
  PaginatedPromotionEventResponse,
  PaginatedRedemptionEventResponse,
  PaginatedResponseBaseResponse,
  PaginatedResponseEntitlementTemplateResponse,
  PaginatedResponseEntitlementTemplateV2Response,
  PaginatedResponseGenericEntitlementResponseString,
  PaginatedResponseInputEventPayload,
  PaginatedResponseMigrationResponse,
  PaginatedResponseOfferingGroupResponse,
  PaginatedResponseOfferingRelationshipResponse,
  PaginatedResponseOfferingResponse,
  PaginatedResponseOfferingV2Response,
  PaginatedResponsePricingChangeResponse,
  PaginatedResponsePricingPlanResponse,
  PaginatedResponseProductResponse,
  PartnerStatusDto,
  PatchInvoiceGroupInput,
  PatchOpenQuoteRequest,
  PatchOpenQuoteResponse,
  PatchPaymentMethodInput,
  PatchPromotionDetailsRequestV2,
  PatchPromotionResponseV2,
  PaymentMethodDto,
  PaymentMethodInput,
  PaymentMethodMigrationRequestDto,
  PendingInvoiceRequestListDto,
  PricingChangeInput,
  PricingChangeResponse,
  PricingChangeUpdateInput,
  PricingPlanInput,
  PricingPlanResponse,
  PricingPlanUpdateInput,
  ProductInput,
  ProductPatchUpdateInput,
  ProductResponse,
  ProductUpdateInput,
  PromotionChangeRouteRequest,
  PromotionChangeRouteResponse,
  PromotionCodeResponse,
  PromotionCodesExhaustedRequest,
  PromotionCodesExhaustedResponse,
  PromotionErrorResponse,
  QueryRequest,
  RecipientsDto,
  RecipientsInput,
  RedeemPromotionCodeRequest,
  RedeemPromotionCodeResponse,
  ReviseQuoteRequest,
  ReviseQuoteResponse,
  RewindToDetailsResponseDto,
  RoleAssignment,
  RoleAssignments,
  RoleResourceInput,
  SetupConfirmPayment,
  SetupIntent,
  SetupIntentInput,
  ShipToPartyDto,
  ShipToPartyInput,
  SubscriptionErrorResponse,
  SyntheticPlanTemplateInput,
  SyntheticPlanTemplateResponse,
  SyntheticPlanTemplateUpdatableFieldsInput,
  TransactionAccountDto,
  TransactionAccountEvent,
  TransactionAccountInput,
  TransactionAccountsListDto,
  TransactionAccountStatus,
  TrialInput,
  TrialResponse,
  UpdateEntityExtensionDataInput,
  UpdateEntityIgnoreRuleRequest,
  UpdateInvoiceGroupInput,
  UpdateInvoiceInput,
  UpdatePriceEligibility1Payload,
  UpdatePriceEligibilityPayload,
  UpdateProductIgnoreRuleResponse,
  UpdatePromotionDetailsRequestV2,
  UpdatePromotionEventStatusRequest,
  UpdatePromotionResponse,
  UpdateQuoteRequest,
  UpdateQuoteResponse,
  UploadObjectDto,
  UsersListDto,
  UtsEvent,
  V1ArchivesCreatePayload,
  V1OfferingsFetchBatchCreatePayload,
  V1OfferingsSyntheticsGenerateCreatePayload,
  V1OrderIntentCreatePayload,
  V1OrderIntentPreviewCreatePayload,
  V1OrdersCreateBody,
  V1PricingPlansFetchBatchCreatePayload,
  V1ProductsFetchBatchCreatePayload,
  V2OfferingsFetchBatchCreatePayload,
} from "./data-contracts";

export type {
  AcceptQuoteLineItemRequest,
  AcceptQuoteLineItemRequest5,
  AcceptQuoteRequest,
  AcceptQuoteResponse,
  AccountDetails,
  AccountModificationDto,
  ActivateInput,
  ActivateResponse,
  ActivePricingPlanCountResponse,
  AddUserDefinedNotePayload,
  AdhocInvoice,
  AdhocInvoiceCreationInput,
  Aggregation,
  AllDetailsForProcessingInfoDto,
  AllDetailsOrderItemResponseDto,
  AndRuleConditionDto,
  ApiError,
  ApiGatewayErrorResponse,
  ApplicabilityContext,
  ApplicablePromotionCodeProductKeyDto,
  ApplicablePromotionCodesRequest,
  ApplicablePromotionCodesResponse,
  ApplicablePromotionFiltersDto,
  ApplicablePromotionRequestV2,
  ApplicablePromotionResponse,
  ApplicationContext,
  ApplicationReason,
  ApplicationReasonDto,
  ApplicationReasonRequestDto,
  ApplicationReasonResponseDto,
  ApplicationReasonResponseSetLimiterDto,
  ArchivedObjectConfigPropertyDto,
  ArchivedObjectConfiguration,
  ArchivedObjectDto,
  ArchivedObjectInput,
  AuditLogDto,
  AuthorContextDto,
  AvailablePromotionRequest,
  AvailablePromotionResponse,
  BaseEligibleConditionDto,
  BaseResponse,
  BEChargeDetail,
  BehaviourAtEndOfTrial,
  Benefit,
  BenefitDto,
  BillAdjustmentDto,
  BillEstimateAdjustment,
  BillEstimateChargeQuantity,
  BillEstimateInvoiceOriginalItemReferral,
  BillEstimateItem,
  BillEstimateItemResponseDto,
  BillEstimatePeriod,
  BillEstimateResponse,
  BillFromDto,
  BillingAnchorDto,
  BillingAnchorTime,
  BillingClockRequest,
  BillingClockResponseDto,
  BillingOptionsDto,
  BillingPeriodDetails,
  BillPeriodDto,
  BillToDto,
  BillToDurationDto,
  BillToParty,
  BillToPartyDto,
  BillToPartyInput,
  BillUntilDto,
  BooleanQuery,
  Break,
  CanceledReasonResponse,
  CancelQuoteRequest,
  CancelQuoteResponse,
  CardDetails,
  Cardinality,
  CatalogAccountResponse,
  CCPInvoiceItemReferral,
  CcpItemReferralInput,
  ChangeDetails,
  ChangeInput,
  ChangeResponse,
  ChargeDetails,
  ChargeElementData,
  ChargeQuantity,
  ChargeQuantityDefaultAPI,
  ChargeQuantityDto,
  ChargingDetailsDto,
  CheckRoleAssignmentPermissionParams,
  CloneQuoteRequest,
  CloneQuoteResponse,
  CohortInput,
  CohortResponse,
  ComputedDetails,
  Constraint,
  Context,
  CountQueryRequest,
  CountQueryResponse,
  CouplingConfig,
  CouplingViolationResponse,
  CreateCreditNotePayload,
  CreateEntityIgnoreRuleRequest,
  CreateInvoiceGroupInput,
  CreateOfferingChangeRequest,
  CreateOfferingRelationshipTemplateRequest,
  CreateProductIgnoreRuleResponse,
  CreatePromotionCodesRequest,
  CreatePromotionRequestV2,
  CreatePromotionResponseV2,
  CreateQuoteRequest,
  CreateQuoteResponse,
  CreateRandomPromotionCodesRequest,
  CreditCard,
  CreditGrantCreditNoteInput,
  CreditNoteDto,
  CreditNoteInput,
  CreditNoteItemDto,
  CreditNoteItemInput,
  CreditObjDto,
  CreditObjInput,
  CustomerBalanceDto,
  CustomerBalanceTransaction,
  CustomerBalanceTransactionListDto,
  CustomisableApplicationReasonRequestDto,
  CustomisableApplicationReasonResponseDto,
  CustomisedValues,
  CustomizationSet,
  CustomPromotionValueDto,
  Cycle,
  CycleInput,
  CycleResponse,
  Data,
  DeactivateInput,
  DeactivateResponse,
  DecimalLimiterDto,
  DecimalRangeLimiterDto,
  DecimalSetLimiterDto,
  DefaultPricingPlanResponse,
  Deferred,
  DeferredInput,
  DeletePaymentMethodInput,
  DeleteProductIgnoreRuleResponse,
  DeleteRoleInput,
  DependsOnOfferingInput,
  DerivedFromOffering,
  DerivedOffering,
  DiscountDetailResponse,
  DiscountDto,
  DunningAttemptInput,
  DunningCancellationCreditNoteInput,
  DunningStatus,
  Duration,
  DurationDto,
  EffectiveTimeDto,
  EligibilityRuleDto,
  EligiblePromotionWindow,
  EligiblePromotionWindowRequest,
  EligiblePromotionWindowResponse,
  EndsAtDto,
  EndTimestamp,
  EntitlementDetails,
  EntitlementErrorResponse,
  EntitlementHistoryDto,
  EntitlementRef,
  EntitlementRelationship,
  EntitlementRelationshipDto,
  EntitlementRelationshipInDetailsApi,
  EntitlementResponse,
  EntitlementSlugValidateResponse,
  EntitlementStateResponse,
  EntitlementSummary,
  EntitlementTemplate,
  EntitlementTemplateInput,
  EntitlementTemplateResponse,
  EntitlementTemplateUpdateInput,
  EntitlementTemplateV2Response,
  EntitlementTransitionResponse,
  EntitlementTraversalItem,
  EntitlementTraversalRequestDto,
  EntitlementTraversalResponseDto,
  EntityExtensionDataResponse,
  EntityIgnoreRuleEligibilityRuleDto,
  ErrorCode,
  ErrorDetails,
  ErrorResponse,
  EstimateLineResponse,
  EstimateResponse,
  EstimateTaxDto,
  EstimateTaxInput,
  EstimateTaxItemDto,
  EstimateTaxItemDtoFeeDetails,
  EstimateTaxItemDtoMetadata,
  EstimateTaxItemInput,
  ExampleFileUploadRequest,
  ExternInvoiceItemReferral,
  FinalizeQuoteRequest,
  FinalizeQuoteResponse,
  FullItemRefundCreditNoteInput,
  GenerateSyntheticPlansInput,
  GenericErrorDetails,
  GenericPaginatedResponse,
  GetAllParams,
  GetAllRedemptionsByPromotionIdAndPromotionCodeParams,
  GetAuditLogsParams,
  GetAvailablePromotionParams,
  GetInvoice2Params,
  GetInvoiceGroupsParams,
  GetInvoiceRequestsParams,
  GetInvoicesParams,
  GetOrderDefaultParams,
  GetPaginatedRedemptionsParams,
  GetPaymentMethodsParams,
  GetPendingInvoiceRequestsParams,
  GetProductIgnoreRuleResponse,
  GetPromotionByIdResponseV2,
  GetPromotionCodeResponse,
  GetPromotionCodesByPromotionIdAndStatusParams,
  GetQuoteResponse,
  GetRedeemPromotionCodeResponse,
  GetRedemptionsResponse,
  GetStatus1Params,
  Group,
  HeaderTaxId,
  ImpactedEntitlementDto,
  ImplicitOrderDto,
  InputEventPayload,
  IntegerLimiterDto,
  IntegerRangeLimiterDto,
  IntegerSetLimiterDto,
  InvoiceDto,
  InvoiceGroupDto,
  InvoiceGroupId,
  InvoiceGroupStatus,
  InvoiceItem,
  InvoiceItemAdjustment,
  InvoiceRequest,
  InvoiceRequestInput,
  InvoiceRequestItem,
  InvoiceRequestItemAdjustment,
  InvoiceRequestItemAdjustmentInput,
  InvoiceRequestItemInput,
  InvoiceRequestListDto,
  Issue,
  ItemValidationErrorResponseDto,
  JsonNode,
  JsonNullableSetString,
  JsonNullableString,
  JsonPatch,
  JsonPatchOperation,
  LicenseCouplingViolationErrorResponse,
  LineItemEndsAtDto,
  LineItemRequest,
  LineItemResponse,
  LineItemValidationErrorResponseDto,
  LineStatusReasonResponse,
  Links,
  LockContextDto,
  MarkDraftQuoteRequest,
  MarkDraftQuoteResponse,
  Metadata,
  MigrateInput,
  MigratePaymentMethodInput,
  MigrateResponse,
  MigrationCreatePromotionCodeRequest,
  MigrationCreatePromotionCodeResponse,
  MigrationCreatePromotionRequest,
  MigrationDestinationInput,
  MigrationDestinationResponse,
  MigrationEntitlementHistoryDto,
  MigrationRedeemPromotionCodeRequest,
  MigrationResponse,
  NextCycleChange,
  NextCycleChargeDetails,
  NonCcpItemReferralInput,
  NotApplicablePromotionResponse,
  NoteDto,
  OfferingChangeInput,
  OfferingChangeInputResponse,
  OfferingChangeResponse,
  OfferingChangeUpdateInput,
  OfferingDeactivateInput,
  OfferingDeactivateResponse,
  OfferingDetailsResponse,
  OfferingErrorResponse,
  OfferingGroupResponse,
  OfferingInput,
  OfferingMigrateInput,
  OfferingMigrateResponse,
  OfferingMigrationDestinationInput,
  OfferingMigrationDestinationResponse,
  OfferingPatchUpdateInput,
  OfferingRelationshipDto,
  OfferingRelationshipResponse,
  OfferingRelationshipTemplateResponse,
  OfferingResponse,
  OfferingSlugsInput,
  OfferingTransitionDto,
  OfferingUpdateInput,
  OfferingV2Response,
  OmsPromotionDto,
  OperationConfig,
  OptedUsageOptionDto,
  OrchestrationResponse,
  Order,
  OrderAccountModificationItemDto,
  OrderAmendmentItemDto,
  OrderBillEstimateItemResponseDto,
  OrderBillEstimateResponseDto,
  OrderCancellationItemDto,
  OrderCreationItemDto,
  OrderDefault,
  OrderedApplicablePromotionResponse,
  OrderEntitlementRefDto,
  OrderEntitlementRefForMigrationOrder,
  OrderGetResponseDto,
  OrderIntentGetResponseDto,
  OrderIntentItemGetResponseDto,
  OrderIntentResponseDto,
  OrderIntentWebRequestDto,
  OrderIntentWithOrderItemsLegacyWebRequestDto,
  OrderIntentWithOrderItemsWebRequestDto,
  OrderIntentWithQuoteWebRequestDto,
  OrderItemGetResponseDto,
  OrderItemRefDto,
  OrderItemRequestDto,
  OrderItemResponseDto,
  OrderReactivationItemDto,
  OrderRebillItemDto,
  OrderRequestDto,
  OrderResponseDto,
  OrderRevertTrialItemDto,
  OrderRewindItemDto,
  OrderServiceValidationErrorResponse,
  OrderTransferInItemDto,
  OrderTransferOutItemDto,
  OrderTransitionItemDto,
  OrderWebRequestDto,
  OrderWithQuotesWebRequestDto,
  OriginalExternalItemReferral,
  OriginalInvoiceReferral,
  OriginalItemReferral,
  OriginalItemReferralInput,
  OrRuleConditionDto,
  Outcome,
  OverrideBehavior,
  OverRideDto,
  PagedListArchivedObjectDto,
  PagedListAuditLogDto,
  PagedListInvoiceDto,
  PagedListInvoiceGroupDto,
  PagedListPaymentMethodDto,
  PagedListShipToPartyDto,
  PageRequest,
  PageResponsePromotionCodeResponse,
  PaginatedOrderItemResponseDto,
  PaginatedPromotionEventResponse,
  PaginatedRedemptionEventResponse,
  PaginatedResponseBaseResponse,
  PaginatedResponseEntitlementTemplateResponse,
  PaginatedResponseEntitlementTemplateV2Response,
  PaginatedResponseGenericEntitlementResponseString,
  PaginatedResponseInputEventPayload,
  PaginatedResponseMigrationResponse,
  PaginatedResponseOfferingGroupResponse,
  PaginatedResponseOfferingRelationshipResponse,
  PaginatedResponseOfferingResponse,
  PaginatedResponseOfferingV2Response,
  PaginatedResponsePricingChangeResponse,
  PaginatedResponsePricingPlanResponse,
  PaginatedResponseProductResponse,
  Participant,
  PartnerStatusDto,
  PatchEntitlementItemDto,
  PatchInvoiceGroupInput,
  PatchOpenQuoteRequest,
  PatchOpenQuoteResponse,
  PatchPaymentMethodInput,
  PatchPromotionDetailsRequestV2,
  PatchPromotionResponseV2,
  Payload,
  PaymentMethodDto,
  PaymentMethodInput,
  PaymentMethodMigrationRequestDto,
  PaymentStatus,
  PayPal,
  PendingInvoiceRequestListDto,
  Period,
  PeriodInput,
  PeriodResponse,
  Plan,
  PlanInput,
  PostalAddress,
  PrebillDto,
  PreBillingConfigurationDto,
  PreDunning,
  PreDunningAttempt,
  PricingChangeInput,
  PricingChangeResponse,
  PricingChangeUpdateInput,
  PricingPlan,
  PricingPlanInput,
  PricingPlanItemInput,
  PricingPlanItemResponse,
  PricingPlanRelationshipResponse,
  PricingPlanResponse,
  PricingPlanTierInput,
  PricingPlanTierResponse,
  PricingPlanTransitionDto,
  PricingPlanUpdateInput,
  PrincipalsByResourceRolesParams,
  PrincipalsByResourceRolesRequest,
  PrincipalsByResourceRolesResponse,
  ProcessingInfo,
  ProcessingInfoResponseDto,
  ProductInput,
  ProductPatchUpdateInput,
  ProductResponse,
  ProductUpdateInput,
  PromotionBenefitCustomisableDto,
  PromotionBenefitDto,
  PromotionChangeRouteRequest,
  PromotionChangeRouteResponse,
  PromotionCodeApplicabilityContext,
  PromotionCodeModel,
  PromotionCodeResponse,
  PromotionCodesExhaustedRequest,
  PromotionCodesExhaustedResponse,
  PromotionDefinition,
  PromotionDefinitionDto,
  PromotionErrorResponse,
  PromotionInstance,
  PromotionPurposeResponse,
  PromotionRequestDefinition,
  PromotionRequestDto,
  PromotionResponseDefinition,
  PromotionResponseDto,
  PurchaseOrder,
  PurchaseOrderInput,
  Query,
  QueryPrincipalsParams,
  QueryRequest,
  QuoteLineItemDetailsReferenceDto,
  QuoteReferenceWebDto,
  RangeQuery,
  RebillOptionsDto,
  RecipientsDto,
  RecipientsInput,
  RedeemPromotionCodeRequest,
  RedeemPromotionCodeResponse,
  RedemptionResponse,
  RelatesFromDto,
  RelatesFromEntitlementDetails,
  RelatesFromEntitlementDto,
  RelatesFromEntitlementResponseDto,
  RelatesFromOrderItemDto,
  RelatesFromOrderItemResponseDto,
  RelatesFromResponseDto,
  Relationship,
  RelationshipData,
  RelationshipNode,
  RelationshipTemplateNode,
  ResourcesByPrincipalRequest,
  Result,
  ReviseQuoteRequest,
  ReviseQuoteResponse,
  RewindOrderRequestDto,
  RewindToDetailsResponseDto,
  RoleAssignment,
  RoleAssignments,
  RoleResourceInput,
  RuleConditionDtoEligibleConditionDto,
  SaleTransitionDetails,
  SaleTransitionDetailsDto,
  SelectorGroup,
  Selectors,
  SetupConfirmPayment,
  SetupIntent,
  SetupIntentInput,
  ShipToPartyDto,
  ShipToPartyInput,
  StaleReasonResponse,
  StartsAtDto,
  StringLimiterDto,
  StringSetLimiterDto,
  Subscription,
  SubscriptionByTierCohort,
  SubscriptionByTierCohortInput,
  SubscriptionErrorResponse,
  SubscriptionGLPDetailsDto,
  SubscriptionInEntitlementDetails,
  SubscriptionInEntitlementDetailsV2,
  SubscriptionInput,
  SubscriptionSchedule,
  SubscriptionScheduleV2,
  SubscriptionSummary,
  SyntheticPlanTemplateInput,
  SyntheticPlanTemplateResponse,
  SyntheticPlanTemplateUpdatableFieldsInput,
  SystemOrderAmendmentItemDto,
  SystemOrderCancellationItemDto,
  TaxId,
  TaxIdInput,
  TaxItem,
  TaxItemDto,
  TaxItemsResponse,
  TaxOnlyRefundCreditNoteInput,
  Terms,
  TestParameterDetails,
  TestParameters,
  TestParametersDto,
  ToPartyDto,
  TransactionAccount,
  TransactionAccountDto,
  TransactionAccountEvent,
  TransactionAccountInput,
  TransactionAccountPartitionDto,
  TransactionAccountResponseDto,
  TransactionAccountsListDto,
  TransactionAccountStatus,
  TransitionDetails,
  TransitionDto,
  TransitionOrderEntitlementRefDto,
  Traverse,
  Trial,
  TrialInput,
  TrialIntentDto,
  TrialResponse,
  UncollectibleActionDestinationInput,
  UncollectibleActionDestinationResponse,
  UncollectibleActionInput,
  UncollectibleActionResponse,
  Until,
  UpdateEntityExtensionDataInput,
  UpdateEntityIgnoreRuleRequest,
  UpdateInvoiceGroupInput,
  UpdateInvoiceInput,
  UpdatePriceEligibility1Payload,
  UpdatePriceEligibilityPayload,
  UpdateProductIgnoreRuleResponse,
  UpdatePromotionDetailsRequestV2,
  UpdatePromotionEventStatusRequest,
  UpdatePromotionResponse,
  UpdateQuoteRequest,
  UpdateQuoteResponse,
  UploadObjectDto,
  UsageUpdateCadenceInput,
  UsageUpdateCadenceResponse,
  User,
  UsersListDto,
  UtsEvent,
  V1ArchivesCreatePayload,
  V1ArchivesItemTypeDetailParams,
  V1BillEstimateListParams,
  V1CustomerBalanceTransactionsListParams,
  V1EntitlementsChildrenDetailParams,
  V1EntitlementsSlugValidateListParams,
  V1EntitlementTemplatesDetailParams,
  V1EntitlementTemplatesHistoryDetailParams,
  V1EntitlementTemplatesListParams,
  V1EntitlementTransitionsDetailParams,
  V1OfferingChangesMigrationsDetailParams,
  V1OfferingRelationshipsBulkFetchListParams,
  V1OfferingRelationshipsListParams,
  V1OfferingRelationshipsMeaningfulDetailParams,
  V1OfferingsChildrenDetailParams,
  V1OfferingsFetchBatchCreatePayload,
  V1OfferingsListParams,
  V1OfferingsPricingChangesDetailParams,
  V1OfferingsPricingPlansDetailParams,
  V1OfferingsPricingPlanTransitionsDetailParams,
  V1OfferingsSyntheticsGenerateCreatePayload,
  V1OrderIntentCreateParams,
  V1OrderIntentCreatePayload,
  V1OrderIntentEstimateCreateParams,
  V1OrderIntentPreviewCreateParams,
  V1OrderIntentPreviewCreatePayload,
  V1OrderItemsListParams,
  V1OrdersCreateBody,
  V1OrdersCreateParams,
  V1PricingChangesMigrationsDetailParams,
  V1PricingPlansEventListParams,
  V1PricingPlansFetchBatchCreatePayload,
  V1PricingPlansListParams,
  V1PricingPlansTransitionsDetailParams,
  V1ProductsEntitlementTemplatesDetailParams,
  V1ProductsEventListParams,
  V1ProductsFetchBatchCreatePayload,
  V1ProductsListParams,
  V1ProductsOfferingGroupsDetailParams,
  V1ProductsOfferingsDetailParams,
  V1QuotesDownloadDetailParams,
  V1QuotesOpenCreateParams,
  V2OfferingsEventListParams,
  V2OfferingsFetchBatchCreatePayload,
  V2OfferingsListParams,
  V2PromotionsListParams,
  ValidationErrorDetails,
  ValidationErrorMessage,
  Validity,
  Wildcard,
  WriteOffCreditNoteInput,
} from "./data-contracts";

export type ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType =
  | Readonly<{ body: ArchivedObjectConfiguration; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 413; response: Omit<Response, "status"> & { status: 413 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>
  | Readonly<{ body: ErrorResponse; status: 509; response: Omit<Response, "status"> & { status: 509 } }>;

/**
 * Tags: "archival-object-configuration-resources"
 * @description
 * Gets configuration for particular itemType(INVOICE/NOTE....) and sourceSystem(HAMS/STATUSPAGE...,)
 */
export const archiveConfigsItemTypeSourceSystem_get_byItemTypeAndSourceSystem_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Item Type ex : Invoice/note etc.., */
      itemType: string;
      /** source system ex : Hams/statuspage etc.., */
      sourceSystem: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType,
      {
        /** Item Type ex : Invoice/note etc.., */
        itemType: string;
        /** source system ex : Hams/statuspage etc.., */
        sourceSystem: string;
      },
      undefined,
      undefined,
      {
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<
    Result<ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType, FetchErrorPayload>
  > => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/archive-configs/item-type/${pathParameters.itemType}/source-system/${pathParameters.sourceSystem}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/archive-configs/item-type/${itemType}/source-system/${sourceSystem}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `archiveConfigsItemTypeSourceSystem_get_byItemTypeAndSourceSystem_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 413:
          case 500:
          case 509:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ArchiveConfigsItemTypeSourceSystemGetByItemTypeAndSourceSystemV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ArchivesPostV1ResponseType =
  | Readonly<{ body: ArchivedObjectDto[]; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 413; response: Omit<Response, "status"> & { status: 413 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>
  | Readonly<{ body: ErrorResponse; status: 509; response: Omit<Response, "status"> & { status: 509 } }>;

/**
 * Tags: "archival-object-resource"
 * @description
 * Create an archived object with metadata
 */
export const archives_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1ArchivesCreatePayload;
    headers: {
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ArchivesPostV1ResponseType,
      undefined,
      undefined,
      V1ArchivesCreatePayload,
      {
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<ArchivesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/archives`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/archives",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `archives_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 409:
          case 413:
          case 500:
          case 509:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ArchivesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ArchivesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ArchivesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ArchivesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ArchivesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ArchivesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ArchivesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ArchivesItemTypeGetByItemTypeV1ResponseType =
  | Readonly<{ body: PagedListArchivedObjectDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 413; response: Omit<Response, "status"> & { status: 413 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>
  | Readonly<{ body: ErrorResponse; status: 509; response: Omit<Response, "status"> & { status: 509 } }>;

/**
 * Tags: "archival-object-resource"
 * @description
 * Fetch archives
 */
export const archivesItemType_get_byItemType_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      itemType: string;
    };
    queryParameters: {
      sourceSystem: string;
      /**
       * @format int32
       * @default 10
       */
      pageSize?: number;
      startId?: string;
      filtersMap: Record<string, string>;
    };
    headers: {
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ArchivesItemTypeGetByItemTypeV1ResponseType,
      {
        itemType: string;
      },
      {
        sourceSystem: string;
        /**
         * @format int32
         * @default 10
         */
        pageSize?: number;
        startId?: string;
        filtersMap: Record<string, string>;
      },
      undefined,
      {
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<ArchivesItemTypeGetByItemTypeV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/archives/item-type/${pathParameters.itemType}`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/archives/item-type/${itemType}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `archivesItemType_get_byItemType_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 413:
          case 500:
          case 509:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ArchivesItemTypeGetByItemTypeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ArchivesItemTypeGetByItemTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ArchivesItemTypeGetByItemTypeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ArchivesItemTypeGetByItemTypeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ArchivesItemTypeGetByItemTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ArchivesItemTypeGetByItemTypeV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ArchivesItemTypeGetByItemTypeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ArchivesUploadPostV1ResponseType =
  | Readonly<{ body: UploadObjectDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: UploadObjectDto; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 413; response: Omit<Response, "status"> & { status: 413 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>
  | Readonly<{ body: ErrorResponse; status: 509; response: Omit<Response, "status"> & { status: 509 } }>;

/**
 * Tags: "archival-object-resource"
 * @description
 * Upload an object with metadata
 */
export const archivesUpload_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ExampleFileUploadRequest;
    headers: {
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ArchivesUploadPostV1ResponseType,
      undefined,
      undefined,
      ExampleFileUploadRequest,
      {
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<ArchivesUploadPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/archives/upload`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/archives/upload",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `archivesUpload_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 201:
          case 400:
          case 404:
          case 409:
          case 413:
          case 500:
          case 509:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ArchivesUploadPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ArchivesUploadPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ArchivesUploadPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ArchivesUploadPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ArchivesUploadPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ArchivesUploadPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ArchivesUploadPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type AuditLogsGetV1ResponseType =
  | Readonly<{ body: PagedListAuditLogDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "audit-log-resource"
 * @description
 * Get the audit logs of the given transaction account in `X-transaction-account` header, or the given scope (e.g. GLOBAL) and resource id in the query params.
 */
export const auditLogs_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      scope?: string;
      "resource-id"?: string;
      paging: PageRequest;
    };
    headers?: {
      /** User Context */
      "User-Context"?: string;
      "X-transaction-account"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      AuditLogsGetV1ResponseType,
      undefined,
      {
        scope?: string;
        "resource-id"?: string;
        paging: PageRequest;
      },
      undefined,
      | {
          /** User Context */
          "User-Context"?: string;
          "X-transaction-account"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<AuditLogsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/audit-logs`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/audit-logs",
        method: "GET",
        operationId: "getAuditLogs",
        summary: null,
        methodName: `auditLogs_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & AuditLogsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<AuditLogsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & AuditLogsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<AuditLogsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<AuditLogsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<AuditLogsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as AuditLogsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillToPartyGetV1ResponseType =
  | Readonly<{ body: BillToParty; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "bill-to-party-resource"
 * @description
 * Retrieves the bill-to-party of a transaction account
 */
export const billToParty_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      BillToPartyGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<BillToPartyGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/bill-to-party`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/bill-to-party",
        method: "GET",
        operationId: "get_1",
        summary: null,
        methodName: `billToParty_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 204:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillToPartyGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillToPartyGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillToPartyGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<BillToPartyGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillToPartyGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillToPartyGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillToPartyGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillToPartyPutV1ResponseType =
  | Readonly<{ body: BillToParty; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "bill-to-party-resource"
 * @description
 * Update bill-to-party of the transaction account
 */
export const billToParty_put_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: BillToPartyInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      BillToPartyPutV1ResponseType,
      undefined,
      undefined,
      BillToPartyInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<BillToPartyPutV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/bill-to-party`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/bill-to-party",
        method: "PUT",
        operationId: "update",
        summary: null,
        methodName: `billToParty_put_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillToPartyPutV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillToPartyPutV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillToPartyPutV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<BillToPartyPutV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillToPartyPutV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillToPartyPutV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillToPartyPutV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillToPartyPriceEligibilityGetV1ResponseType =
  | Readonly<{ body: Record<string, boolean>; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "bill-to-party-resource"
 * @description
 * Retrieves the price eligibility of the transaction accounts' bill to party
 */
export const billToPartyPriceEligibility_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      BillToPartyPriceEligibilityGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<BillToPartyPriceEligibilityGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/bill-to-party/price-eligibility",
        method: "GET",
        operationId: "getPriceEligibility_1",
        summary: null,
        methodName: `billToPartyPriceEligibility_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillToPartyPriceEligibilityGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillToPartyPriceEligibilityGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillToPartyPriceEligibilityGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  BillToPartyPriceEligibilityGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillToPartyPriceEligibilityGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillToPartyPriceEligibilityGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillToPartyPriceEligibilityGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillToPartyPriceEligibilityPutV1ResponseType =
  | Readonly<{ body: Record<string, boolean>; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "bill-to-party-resource"
 * @description
 * Update the price eligibility of the transaction accounts' bill to party
 */
export const billToPartyPriceEligibility_put_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdatePriceEligibility1Payload;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      BillToPartyPriceEligibilityPutV1ResponseType,
      undefined,
      undefined,
      UpdatePriceEligibility1Payload,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<BillToPartyPriceEligibilityPutV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/bill-to-party/price-eligibility",
        method: "PUT",
        operationId: "updatePriceEligibility_1",
        summary: null,
        methodName: `billToPartyPriceEligibility_put_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillToPartyPriceEligibilityPutV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillToPartyPriceEligibilityPutV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillToPartyPriceEligibilityPutV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  BillToPartyPriceEligibilityPutV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillToPartyPriceEligibilityPutV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillToPartyPriceEligibilityPutV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillToPartyPriceEligibilityPutV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillEstimateGetV1ResponseType =
  | Readonly<{ body: BillEstimateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Bill Estimate APIs"
 */
export const billEstimate_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      entitlementId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      BillEstimateGetV1ResponseType,
      undefined,
      {
        entitlementId: string;
      },
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<BillEstimateGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/bill/estimate`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/bill/estimate",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `billEstimate_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillEstimateGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillEstimateGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillEstimateGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<BillEstimateGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillEstimateGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillEstimateGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillEstimateGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type BillingAdminsGetV1ResponseType =
  | Readonly<{ body: UsersListDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "billing-admin-resource"
 * @description
 * Get the billing admins of given transaction account
 */
export const billingAdmins_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      BillingAdminsGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<BillingAdminsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/billing-admins`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/billing-admins",
        method: "GET",
        operationId: "getBillingAdmins",
        summary: null,
        methodName: `billingAdmins_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & BillingAdminsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<BillingAdminsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & BillingAdminsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<BillingAdminsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<BillingAdminsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<BillingAdminsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as BillingAdminsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CatalogAccountsGetByKeyV1ResponseType =
  | Readonly<{ body: CatalogAccountResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Catalog Account"
 * @summary
 * Get catalog account by key
 */
export const catalogAccounts_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      CatalogAccountsGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<CatalogAccountsGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/catalog-accounts/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/catalog-accounts/${key}",
        method: "GET",
        operationId: null,
        summary: "Get catalog account by key ",
        methodName: `catalogAccounts_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CatalogAccountsGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CatalogAccountsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CatalogAccountsGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<CatalogAccountsGetByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CatalogAccountsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CatalogAccountsGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CatalogAccountsGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CreditNotesPostV1ResponseType =
  | Readonly<{ body: CreditNoteDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "credit-note-resource"
 * @description
 * A credit note has several states that it transitions through. When you POST to this endpoint a credit note is saved to our db in a PENDING state. At this stage there is no guarantee that the credit note will be processed because stripe may still reject it. Once we send the credit note to Stripe and we receive a success response the credit note transitions to an OPEN state. In this state the refund hasn't been credited to a card but is finalised, it is only a matter of time until the refund is attempted.
 *  *
 *  * There are several validation checks that are performed to ensure the credit note can be processed:
 *  * For any type of credit note:
 *  * * There cant be previous tax-only-refund credit note for the same invoiceId.
 *  *
 *  * For tax-only-refund credit notes:
 *  * * No entitlements can be included in the input because the credit note applies to all non-refunded entitlements in the invoice.
 *  * * There can not be any PENDING credit notes that are yet to be sent to stripe.
 *  *
 *  * For full-item-refund credit notes:
 *  * * The entitlementIds in the input must exist in the specified invoice.
 *  * * There must be no previous credit notes for the invoice that have any of the entitlementIds in the input.
 *  *
 *  * For credit-grant credit notes:
 *  * * The entitlementIds in the input must exist in the specified invoice and not be refunded already.
 *  * * Invoice is PAID or DEFERRED_PAID.
 *  * * Credit grant amount <= total entitlement amount.
 *  *
 */
export const creditNotes_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateCreditNotePayload;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      CreditNotesPostV1ResponseType,
      undefined,
      undefined,
      CreateCreditNotePayload,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<CreditNotesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/credit-notes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/credit-notes",
        method: "POST",
        operationId: "createCreditNote",
        summary: null,
        methodName: `creditNotes_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CreditNotesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CreditNotesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CreditNotesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<CreditNotesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CreditNotesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CreditNotesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CreditNotesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CreditNotesGetByIdV1ResponseType =
  | Readonly<{ body: CreditNoteDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "credit-note-resource"
 * @description
 * Retrieve a credit note by id
 */
export const creditNotes_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      CreditNotesGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<CreditNotesGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/credit-notes/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/credit-notes/${id}",
        method: "GET",
        operationId: "getCreditNote",
        summary: null,
        methodName: `creditNotes_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CreditNotesGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CreditNotesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CreditNotesGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<CreditNotesGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CreditNotesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CreditNotesGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CreditNotesGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CreditNotesPaidPostByIdV1ResponseType =
  | Readonly<{ body: CreditNoteDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "credit-note-resource"
 * @description
 * Set credit note's state from OPEN to PAID for PUSH payment methods only
 */
export const creditNotesPaid_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      CreditNotesPaidPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<CreditNotesPaidPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/credit-notes/${pathParameters.id}/paid`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/credit-notes/${id}/paid",
        method: "POST",
        operationId: "markCreditNotePaid",
        summary: null,
        methodName: `creditNotesPaid_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CreditNotesPaidPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CreditNotesPaidPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CreditNotesPaidPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<CreditNotesPaidPostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CreditNotesPaidPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CreditNotesPaidPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CreditNotesPaidPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CustomerBalanceGetV1ResponseType =
  | Readonly<{ body: CustomerBalanceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "customer-balance-resource"
 * @description
 * Returns the customer balance(s) for a transaction account.
 */
export const customerBalance_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      CustomerBalanceGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<CustomerBalanceGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/customer-balance`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/customer-balance",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `customerBalance_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CustomerBalanceGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CustomerBalanceGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CustomerBalanceGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<CustomerBalanceGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CustomerBalanceGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CustomerBalanceGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CustomerBalanceGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type CustomerBalanceTransactionsGetV1ResponseType =
  | Readonly<{
      body: CustomerBalanceTransactionListDto;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "customer-balance-resource"
 * @description
 * Returns the Customer balance transaction List
 */
export const customerBalanceTransactions_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      currency: "USD";
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      CustomerBalanceTransactionsGetV1ResponseType,
      undefined,
      {
        currency: "USD";
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<CustomerBalanceTransactionsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/customer-balance/transactions`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/customer-balance/transactions",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `customerBalanceTransactions_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & CustomerBalanceTransactionsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<CustomerBalanceTransactionsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & CustomerBalanceTransactionsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  CustomerBalanceTransactionsGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<CustomerBalanceTransactionsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<CustomerBalanceTransactionsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as CustomerBalanceTransactionsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTemplatesGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseEntitlementTemplateResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Entitlement Template"
 * @description
 * List all entitlement templates
 */
export const entitlementTemplates_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTemplatesGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<EntitlementTemplatesGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlement-templates`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement-templates",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `entitlementTemplates_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementTemplatesGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTemplatesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTemplatesGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<EntitlementTemplatesGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTemplatesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTemplatesGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTemplatesGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTemplatesDeleteByKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Entitlement Template"
 * @description
 * Delete entitlement template
 */
export const entitlementTemplates_delete_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTemplatesDeleteByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementTemplatesDeleteByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement-templates/${key}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `entitlementTemplates_delete_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementTemplatesDeleteByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTemplatesDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTemplatesDeleteByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementTemplatesDeleteByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTemplatesDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTemplatesDeleteByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTemplatesDeleteByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTemplatesGetByKeyV1ResponseType =
  | Readonly<{ body: EntitlementTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Entitlement Template"
 */
export const entitlementTemplates_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    queryParameters?: {
      /** @format int64 */
      version?: number;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTemplatesGetByKeyV1ResponseType,
      {
        key: string;
      },
      | {
          /** @format int64 */
          version?: number;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementTemplatesGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement-templates/${key}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `entitlementTemplates_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementTemplatesGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTemplatesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTemplatesGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementTemplatesGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTemplatesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTemplatesGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTemplatesGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTemplatesPutByKeyV1ResponseType =
  | Readonly<{ body: EntitlementTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Entitlement Template"
 */
export const entitlementTemplates_put_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: EntitlementTemplateUpdateInput;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTemplatesPutByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      EntitlementTemplateUpdateInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementTemplatesPutByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement-templates/${key}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `entitlementTemplates_put_byKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementTemplatesPutByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTemplatesPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTemplatesPutByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementTemplatesPutByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTemplatesPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTemplatesPutByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTemplatesPutByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTemplatesHistoryGetByKeyV1ResponseType =
  | Readonly<{
      body: PaginatedResponseEntitlementTemplateResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Entitlement Template"
 */
export const entitlementTemplatesHistory_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor using entitlement template version */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTemplatesHistoryGetByKeyV1ResponseType,
      {
        key: string;
      },
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor using entitlement template version */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementTemplatesHistoryGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/entitlement-templates/${pathParameters.key}/history`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement-templates/${key}/history",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `entitlementTemplatesHistory_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  EntitlementTemplatesHistoryGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTemplatesHistoryGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTemplatesHistoryGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementTemplatesHistoryGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTemplatesHistoryGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTemplatesHistoryGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTemplatesHistoryGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementTransitionsGetByIdV1ResponseType =
  | Readonly<{ body: EntitlementTransitionResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "entitlement-transition-resource"
 * @summary
 * Get Entitlement transitions by entitlement ID
 */
export const entitlementTransitions_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    queryParameters?: {
      /**
       * orderTypes
       * @default ["REVERT_TRIAL_ORDER"]
       */
      orderTypes?: (
        | "CREATION_ORDER"
        | "AMENDMENT_ORDER"
        | "PATCH_ENTITLEMENT_DETAILS_ORDER"
        | "CANCELLATION_ORDER"
        | "SYSTEM_CANCELLATION_ORDER"
        | "SYSTEM_AMENDMENT_ORDER"
        | "REACTIVATION_ORDER"
        | "ACCOUNT_MODIFICATION_ORDER"
        | "REWIND_ORDER"
        | "REVERT_TRIAL_ORDER"
        | "REBILL_ORDER"
        | "TRANSITION_ORDER"
        | "TRANSFER_IN_ORDER"
        | "TRANSFER_OUT_ORDER"
      )[];
    };
    headers: {
      "X-transaction-account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementTransitionsGetByIdV1ResponseType,
      {
        id: string;
      },
      | {
          /**
           * orderTypes
           * @default ["REVERT_TRIAL_ORDER"]
           */
          orderTypes?: (
            | "CREATION_ORDER"
            | "AMENDMENT_ORDER"
            | "PATCH_ENTITLEMENT_DETAILS_ORDER"
            | "CANCELLATION_ORDER"
            | "SYSTEM_CANCELLATION_ORDER"
            | "SYSTEM_AMENDMENT_ORDER"
            | "REACTIVATION_ORDER"
            | "ACCOUNT_MODIFICATION_ORDER"
            | "REWIND_ORDER"
            | "REVERT_TRIAL_ORDER"
            | "REBILL_ORDER"
            | "TRANSITION_ORDER"
            | "TRANSFER_IN_ORDER"
            | "TRANSFER_OUT_ORDER"
          )[];
        }
      | undefined,
      undefined,
      {
        "X-transaction-account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<EntitlementTransitionsGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlement/${pathParameters.id}/transitions`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlement/${id}/transitions",
        method: "GET",
        operationId: null,
        summary: "Get Entitlement transitions by entitlement ID",
        methodName: `entitlementTransitions_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementTransitionsGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementTransitionsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementTransitionsGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementTransitionsGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementTransitionsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementTransitionsGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementTransitionsGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementsRelationshipsTraversePostV1ResponseType =
  | Readonly<{
      body: EntitlementTraversalResponseDto;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: EntitlementErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Entitlements APIs"
 * @summary
 * Traverse through entitlements with relationships
 */
export const entitlementsRelationshipsTraverse_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: EntitlementTraversalRequestDto;
    headers?: {
      "X-CCP-Context"?: string;
      "X-Transaction-Account"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementsRelationshipsTraversePostV1ResponseType,
      undefined,
      undefined,
      EntitlementTraversalRequestDto,
      | {
          "X-CCP-Context"?: string;
          "X-Transaction-Account"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementsRelationshipsTraversePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlements/relationships/traverse`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlements/relationships/traverse",
        method: "POST",
        operationId: null,
        summary: "Traverse through entitlements with relationships",
        methodName: `entitlementsRelationshipsTraverse_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  EntitlementsRelationshipsTraversePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementsRelationshipsTraversePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementsRelationshipsTraversePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementsRelationshipsTraversePostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementsRelationshipsTraversePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementsRelationshipsTraversePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementsRelationshipsTraversePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementsSlugValidateGetV1ResponseType =
  | Readonly<{
      body: EntitlementSlugValidateResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: EntitlementErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Entitlements APIs"
 * @summary
 * Validate the Entitlement Slug
 */
export const entitlementsSlugValidate_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      /** Entitlement Slug */
      entitlementSlug: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementsSlugValidateGetV1ResponseType,
      undefined,
      {
        /** Entitlement Slug */
        entitlementSlug: string;
      },
      undefined,
      {
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<EntitlementsSlugValidateGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlements/slug/validate`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlements/slug/validate",
        method: "GET",
        operationId: null,
        summary: "Validate the Entitlement Slug",
        methodName: `entitlementsSlugValidate_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementsSlugValidateGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementsSlugValidateGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementsSlugValidateGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementsSlugValidateGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementsSlugValidateGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementsSlugValidateGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementsSlugValidateGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementsGetByEntitlementIdV1ResponseType =
  | Readonly<{ body: EntitlementResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Entitlements APIs"
 * @summary
 * Get an entitlement by ID
 */
export const entitlements_get_byEntitlementId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Entitlement ID */
      entitlementId: string;
    };
    headers?: {
      "X-Transaction-Account"?: string;
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementsGetByEntitlementIdV1ResponseType,
      {
        /** Entitlement ID */
        entitlementId: string;
      },
      undefined,
      undefined,
      | {
          "X-Transaction-Account"?: string;
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementsGetByEntitlementIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlements/${pathParameters.entitlementId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlements/${entitlementId}",
        method: "GET",
        operationId: null,
        summary: "Get an entitlement by ID",
        methodName: `entitlements_get_byEntitlementId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & EntitlementsGetByEntitlementIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementsGetByEntitlementIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementsGetByEntitlementIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementsGetByEntitlementIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementsGetByEntitlementIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementsChildrenGetByEntitlementIdV1ResponseType =
  | Readonly<{
      body: PaginatedResponseGenericEntitlementResponseString;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: EntitlementErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: EntitlementErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Entitlements APIs"
 * @summary
 * Get children of an entitlement by its ID. This API is eventually consistent, please re-try if you do not see all the children attached to an entitlement.
 */
export const entitlementsChildren_get_byEntitlementId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Entitlement ID */
      entitlementId: string;
    };
    queryParameters?: {
      /** Child entitlement status */
      status?: string;
      /** Pagination offset cursor */
      startId?: string;
      /**
       * Page size
       * @format int32
       * @min 1
       * @max 100
       * @default 10
       */
      pageSize?: number;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementsChildrenGetByEntitlementIdV1ResponseType,
      {
        /** Entitlement ID */
        entitlementId: string;
      },
      | {
          /** Child entitlement status */
          status?: string;
          /** Pagination offset cursor */
          startId?: string;
          /**
           * Page size
           * @format int32
           * @min 1
           * @max 100
           * @default 10
           */
          pageSize?: number;
        }
      | undefined,
      undefined,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<EntitlementsChildrenGetByEntitlementIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/entitlements/${pathParameters.entitlementId}/children`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlements/${entitlementId}/children",
        method: "GET",
        operationId: null,
        summary:
          "Get children of an entitlement by its ID. This API is eventually consistent, please re-try if you do not see all the children attached to an entitlement.",
        methodName: `entitlementsChildren_get_byEntitlementId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  EntitlementsChildrenGetByEntitlementIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementsChildrenGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementsChildrenGetByEntitlementIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementsChildrenGetByEntitlementIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementsChildrenGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementsChildrenGetByEntitlementIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementsChildrenGetByEntitlementIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type EntitlementsDetailsGetByEntitlementIdV1ResponseType =
  | Readonly<{ body: EntitlementDetails; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 503;
      response: Omit<Response, "status"> & { status: 503 };
    }>;

/**
 * Tags: "Entitlement Details API"
 * @summary
 * Get details of an entitlement
 */
export const entitlementsDetails_get_byEntitlementId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Entitlement ID */
      entitlementId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      EntitlementsDetailsGetByEntitlementIdV1ResponseType,
      {
        /** Entitlement ID */
        entitlementId: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<EntitlementsDetailsGetByEntitlementIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/entitlements/${pathParameters.entitlementId}/details`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/entitlements/${entitlementId}/details",
        method: "GET",
        operationId: "getEntitlementDetails",
        summary: "Get details of an entitlement",
        methodName: `entitlementsDetails_get_byEntitlementId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 401:
          case 500:
          case 503:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  EntitlementsDetailsGetByEntitlementIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<EntitlementsDetailsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & EntitlementsDetailsGetByEntitlementIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  EntitlementsDetailsGetByEntitlementIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<EntitlementsDetailsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<EntitlementsDetailsGetByEntitlementIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as EntitlementsDetailsGetByEntitlementIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsGetV1ResponseType =
  | Readonly<{ body: PagedListInvoiceGroupDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Get the n invoice groups of the transaction account
 */
export const invoiceGroups_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsGetV1ResponseType,
      undefined,
      {
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups",
        method: "GET",
        operationId: "getInvoiceGroups",
        summary: null,
        methodName: `invoiceGroups_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceGroupsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsPostV1ResponseType =
  | Readonly<{ body: InvoiceGroupDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Create a new invoice group in the transaction account
 */
export const invoiceGroups_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateInvoiceGroupInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsPostV1ResponseType,
      undefined,
      undefined,
      CreateInvoiceGroupInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups",
        method: "POST",
        operationId: "createInvoiceGroup",
        summary: null,
        methodName: `invoiceGroups_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceGroupsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsGetByIdV1ResponseType =
  | Readonly<{ body: InvoiceGroupDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Retrieve invoice group by id
 */
export const invoiceGroups_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}",
        method: "GET",
        operationId: "getInvoiceGroup",
        summary: null,
        methodName: `invoiceGroups_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceGroupsGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsPatchByIdV1ResponseType =
  | Readonly<{ body: InvoiceGroupDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Update the given invoice group. Not allowed to change default payment method for ON TERMS invoice group. Allowed to unset the fields in the invoice group except name. Can provide either a null, or empty or an actual value for the fields. If null is provided, value will be unset. If empty, previous value won't be changed. If value, value of the field will be updated
 */
export const invoiceGroups_patch_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PatchInvoiceGroupInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsPatchByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      PatchInvoiceGroupInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsPatchByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}",
        method: "PATCH",
        operationId: "updateInvoiceGroup_1",
        summary: null,
        methodName: `invoiceGroups_patch_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsPatchByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsPatchByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceGroupsPatchByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsPatchByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsPatchByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsPutByIdV1ResponseType =
  | Readonly<{ body: InvoiceGroupDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Update the given invoice group. Not allowed to change default payment method for ON TERMS invoice group
 */
export const invoiceGroups_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateInvoiceGroupInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      UpdateInvoiceGroupInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}",
        method: "PUT",
        operationId: "updateInvoiceGroup",
        summary: null,
        methodName: `invoiceGroups_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceGroupsPutByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType =
  | Readonly<{ body: PaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Get the effective payment method of the invoice group. First look for default Payment method of invoice group, if not found then look for the default payment method of the transaction account
 */
export const invoiceGroupsEffectivePaymentMethod_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/effective-payment-method`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/effective-payment-method",
        method: "GET",
        operationId: "getEffectivePaymentMethod",
        summary: null,
        methodName: `invoiceGroupsEffectivePaymentMethod_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsEffectivePaymentMethodGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType =
  | Readonly<{ body: Record<string, boolean>; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Get the effective price eligibility by getting BillToParty/PriceEligibility as well as ShipToPartyPriceEligibility APIs and do a boolean OR on presented flags
 */
export const invoiceGroupsEffectivePriceEligibility_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/effective-price-eligibility`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/effective-price-eligibility",
        method: "GET",
        operationId: "getEffectivePriceEligibility",
        summary: null,
        methodName: `invoiceGroupsEffectivePriceEligibility_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsEffectivePriceEligibilityGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsEstimateTaxPostByIdV1ResponseType =
  | Readonly<{ body: EstimateTaxDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Get the tax estimate for the given estimate amount.
 *  *
 *  * In countries like Canada, Government collects taxes at national and state level.
 *  * To show these different taxes, we have taxItems.
 *  * So Tax calculation will have multiple taxes to be considered.
 *  *
 *  * Tax summaries can be constructed by grouping on the taxAmountLabel property.
 *  *
 *  * e.g. multiple tax items - Canada.
 *  * ```
 *  * //InvoiceItem (“item1”)
 *  *   {
 *  *   // other invoice item properties...
 *  *
 *  *    taxItems: [
 *  *       {
 *  *         id: “taxItem1",
 *  *         tax: 5.00,
 *  *         taxPercent: 10.00,
 *  *         taxId: null,
 *  *         taxAmountLabel: “GST”
 *  *       },
 *  *       {
 *  *         id: “taxItem2",
 *  *         tax: 10.00,
 *  *         taxPercent: 20.00,
 *  *         taxId: “bc_tax_id_456”,
 *  *         taxAmountLabel: “HST”
 *  *       }
 *  *     ]
 *  *   },
 *  *
 *  * //InvoiceItem (“item2”)
 *  *   {
 *  *   // other invoice item properties...
 *  *
 *  *    taxItems: [
 *  *       {
 *  *         id: “taxItem1",
 *  *         tax: 3.00,
 *  *         taxPercent: 10.00,
 *  *         taxId: null,
 *  *         taxAmountLabel: “GST”
 *  *       },
 *  *       {
 *  *         id: “taxItem2",
 *  *         tax: 6.00,
 *  *         taxPercent: 20.00,
 *  *         taxId: “bc_tax_id_456”,
 *  *         taxAmountLabel: “HST”
 *  *       }
 *  *     ]
 *  *   }
 *  * ```
 *  * Consumers themselves will need to calculate TaxSummary as below.
 *  *
 *  * ```
 *  * {
 *  *   taxSummary[
 *  *     {
 *  *       id: “taxItem1”,
 *  *       tax: 8.00,     // summed GST of both invoice items
 *  *       taxPercent: 10.00,
 *  *       taxId: null,
 *  *       taxAmountLabel: “GST”
 *  *     },
 *  *     {
 *  *       id: “taxItem2”,
 *  *       tax: 16.00,     // summed HST of both invoice items
 *  *       taxPercent: 20.00,
 *  *       taxId: “bc_tax_id_456",
 *  *       taxAmountLabel: “HST”
 *  *      }
 *  *    ]
 *  *   }
 *  * ```
 *  *
 */
export const invoiceGroupsEstimateTax_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: EstimateTaxInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsEstimateTaxPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      EstimateTaxInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsEstimateTaxPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/estimate-tax`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/estimate-tax",
        method: "POST",
        operationId: "getTaxEstimate",
        summary: null,
        methodName: `invoiceGroupsEstimateTax_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsEstimateTaxPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsEstimateTaxPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsEstimateTaxPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsEstimateTaxPostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsEstimateTaxPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsEstimateTaxPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsEstimateTaxPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType =
  | Readonly<{ body: PendingInvoiceRequestListDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * List the pending invoice requests which have been committed in stripe. This endpoint is used for testing purposes, i.e to be used by ITAP. It should not be used in Prod.
 */
export const invoiceGroupsPendingInvoiceRequests_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    queryParameters: {
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType,
      {
        id: string;
      },
      {
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/invoice-groups/${pathParameters.id}/pending-invoice-requests`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/pending-invoice-requests",
        method: "GET",
        operationId: "getPendingInvoiceRequests",
        summary: null,
        methodName: `invoiceGroupsPendingInvoiceRequests_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsPendingInvoiceRequestsGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsRecipientsGetByIdV1ResponseType =
  | Readonly<{ body: RecipientsDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Retrieve the recipients of the given invoice group
 */
export const invoiceGroupsRecipients_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsRecipientsGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsRecipientsGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/recipients",
        method: "GET",
        operationId: "getRecipients",
        summary: null,
        methodName: `invoiceGroupsRecipients_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsRecipientsGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsRecipientsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsRecipientsGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsRecipientsGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsRecipientsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsRecipientsGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsRecipientsGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsRecipientsPutByIdV1ResponseType =
  | Readonly<{ body: RecipientsDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Adding recipients to the invoice group
 */
export const invoiceGroupsRecipients_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: RecipientsInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsRecipientsPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      RecipientsInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsRecipientsPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/recipients",
        method: "PUT",
        operationId: "setAllRecipients",
        summary: null,
        methodName: `invoiceGroupsRecipients_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsRecipientsPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsRecipientsPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsRecipientsPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsRecipientsPutByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsRecipientsPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsRecipientsPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsRecipientsPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceGroupsStatusGetByIdV1ResponseType =
  | Readonly<{ body: InvoiceGroupStatus; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-group-resource"
 * @description
 * Get the status of an invoice group and whether it is invoiceable
 *  * Invoiceable means that an invoice request will be accepted, Uninvoiceable means it will be rejected
 *  * If invoice group is invoiceable then the `invoiceable` flag will be true but may contain issues with warnings.
 *  * If invoice group is uninvoiceable then the `invoiceable` flag will be false and issues will contain the reasons why.
 *  * Each issue will contain a CODE field that can be used as an identifier and the severity will also be listed.
 *  * The query parameter 'severity' can be set to either WARNING, UNINVOICEABLE, or ERROR, and has a default value of WARNING.
 *  * This can be used to filter which errors are shown - ERRORS will yield all issues with ERROR severity, UNINVOICEABLE covers
 *  * all issues with either UNINVOICEABLE or ERROR severity, and WARNING is a catch-all.
 *  *
 *  * Important note: When using this endpoint for checking the active status of a TxA (by using the ERROR query parameter), the
 *  * uninvoiceable field value should be ignored. The issues field will contain the information for whether the TxA is inactive.
 *  * Severities:
 *  *   WARNING: may cause problems but still invoiceable
 *  *   UNINVOICEABLE: will cause invoice group to be uninvoiceable
 *  *   ERROR: all invoice groups under the TxA are uninvoiceable, as the TxA is inactive
 */
export const invoiceGroupsStatus_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    queryParameters?: {
      /** @default "WARNING" */
      severity?: "WARNING" | "UNINVOICEABLE" | "ERROR";
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceGroupsStatusGetByIdV1ResponseType,
      {
        id: string;
      },
      | {
          /** @default "WARNING" */
          severity?: "WARNING" | "UNINVOICEABLE" | "ERROR";
        }
      | undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceGroupsStatusGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-groups/${pathParameters.id}/status`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-groups/${id}/status",
        method: "GET",
        operationId: "getStatus_1",
        summary: null,
        methodName: `invoiceGroupsStatus_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceGroupsStatusGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceGroupsStatusGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceGroupsStatusGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoiceGroupsStatusGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceGroupsStatusGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceGroupsStatusGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceGroupsStatusGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceRequestsGetV1ResponseType =
  | Readonly<{ body: InvoiceRequestListDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-request-resource"
 * @description
 * Retrieve invoice requests by status(OPEN/PENDING, INVOICED, UNINVOICEABLE) or/and invoice group. Currently this endpoint only supports to retrieve OPEN/PENDING invoice requests
 */
export const invoiceRequests_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      invoiceGroup?: string;
      statusFilter: "OPEN" | "PENDING" | "INVOICED" | "UNINVOICEABLE";
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceRequestsGetV1ResponseType,
      undefined,
      {
        invoiceGroup?: string;
        statusFilter: "OPEN" | "PENDING" | "INVOICED" | "UNINVOICEABLE";
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceRequestsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-requests`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-requests",
        method: "GET",
        operationId: "getInvoiceRequests",
        summary: null,
        methodName: `invoiceRequests_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceRequestsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceRequestsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceRequestsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceRequestsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceRequestsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceRequestsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceRequestsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoiceRequestsPostV1ResponseType =
  | Readonly<{ body: InvoiceRequest; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-request-resource"
 * @description
 * Accepted amount's precision in this APIs is per currency and matching the Stripe's precision.<br/>&emsp;USD amount accepted in cents<br/>&emsp;AUD amount accepted in cents<br/>&emsp;JPY amount accepted in yen<br/>
 */
export const invoiceRequests_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: InvoiceRequestInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** @default "" */
      "Idempotency-key"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoiceRequestsPostV1ResponseType,
      undefined,
      undefined,
      InvoiceRequestInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** @default "" */
        "Idempotency-key"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoiceRequestsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoice-requests`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoice-requests",
        method: "POST",
        operationId: "createInvoiceRequest",
        summary: null,
        methodName: `invoiceRequests_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoiceRequestsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoiceRequestsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoiceRequestsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoiceRequestsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoiceRequestsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoiceRequestsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoiceRequestsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesGetV1ResponseType =
  | Readonly<{ body: PagedListInvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * If the query param statusFilter is not present, all invoice are listed.
 *  * If statusFilter=PAID (case-sensitive), only paid invoice (instant or deferred) are included.
 *  * If statusFilter=UNPAID (case-sensitive), only unpaid invoices (that are finalised) are included.
 */
export const invoices_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      invoiceGroup?: string;
      /** PAID Includes invoices with status PAID or DEFERRED_PAID, UNPAID Includes invoices with status OPEN or UNCOLLECTIBLE. */
      statusFilter?: "PAID" | "UNPAID";
      paging: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesGetV1ResponseType,
      undefined,
      {
        invoiceGroup?: string;
        /** PAID Includes invoices with status PAID or DEFERRED_PAID, UNPAID Includes invoices with status OPEN or UNCOLLECTIBLE. */
        statusFilter?: "PAID" | "UNPAID";
        paging: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices",
        method: "GET",
        operationId: "getInvoices",
        summary: null,
        methodName: `invoices_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoicesGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesPostV1ResponseType =
  | Readonly<{ body: AdhocInvoice; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * In order to create on demand invoice
 */
export const invoices_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: AdhocInvoiceCreationInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesPostV1ResponseType,
      undefined,
      undefined,
      AdhocInvoiceCreationInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices",
        method: "POST",
        operationId: "createAdhocInvoice",
        summary: null,
        methodName: `invoices_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 202:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoicesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesGetByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Retrieve the invoice by id.
 *  *
 *  * In countries like Canada, Government collects taxes at national and state level.
 *  * To show these different taxes, we have taxItems.
 *  * So Tax calculation will have multiple taxes to be considered.
 *  *
 *  * Tax summaries can be constructed by grouping on the taxAmountLabel property.
 *  *
 *  * e.g. multiple tax items - Canada.
 *  * ```
 *  * //InvoiceItem (“item1”)
 *  *   {
 *  *   // other invoice item properties...
 *  *
 *  *    taxItems: [
 *  *       {
 *  *         id: “taxItem1",
 *  *         tax: 5.00,
 *  *         taxPercent: 10.00,
 *  *         taxId: null,
 *  *         taxAmountLabel: “GST”
 *  *       },
 *  *       {
 *  *         id: “taxItem2",
 *  *         tax: 10.00,
 *  *         taxPercent: 20.00,
 *  *         taxId: “bc_tax_id_456”,
 *  *         taxAmountLabel: “HST”
 *  *       }
 *  *     ]
 *  *   },
 *  *
 *  * //InvoiceItem (“item2”)
 *  *   {
 *  *   // other invoice item properties...
 *  *
 *  *    taxItems: [
 *  *       {
 *  *         id: “taxItem1",
 *  *         tax: 3.00,
 *  *         taxPercent: 10.00,
 *  *         taxId: null,
 *  *         taxAmountLabel: “GST”
 *  *       },
 *  *       {
 *  *         id: “taxItem2",
 *  *         tax: 6.00,
 *  *         taxPercent: 20.00,
 *  *         taxId: “bc_tax_id_456”,
 *  *         taxAmountLabel: “HST”
 *  *       }
 *  *     ]
 *  *   }
 *  * ```
 *  * Consumers themselves will need to calculate TaxSummary as below.
 *  *
 *  * ```
 *  * {
 *  *   taxSummary[
 *  *     {
 *  *       id: “taxItem1”,
 *  *       tax: 8.00,     // summed GST of both invoice items
 *  *       taxPercent: 10.00,
 *  *       taxId: null,
 *  *       taxAmountLabel: “GST”
 *  *     },
 *  *     {
 *  *       id: “taxItem2”,
 *  *       tax: 16.00,     // summed HST of both invoice items
 *  *       taxPercent: 20.00,
 *  *       taxId: “bc_tax_id_456",
 *  *       taxAmountLabel: “HST”
 *  *      }
 *  *    ]
 *  *   }
 *  * ```
 *  *
 */
export const invoices_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}",
        method: "GET",
        operationId: "getInvoice",
        summary: null,
        methodName: `invoices_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoicesGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesPatchByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * To update editable invoice properties of a paid invoice
 */
export const invoices_patch_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateInvoiceInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesPatchByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      UpdateInvoiceInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesPatchByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}",
        method: "PATCH",
        operationId: "updateInvoice",
        summary: null,
        methodName: `invoices_patch_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesPatchByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesPatchByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoicesPatchByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesPatchByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesPatchByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesConfirmPaymentPostByIdV1ResponseType =
  | Readonly<{ body: SetupConfirmPayment; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Retrieve the data required to confirm a card payment with Stripe.
 */
export const invoicesConfirmPayment_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesConfirmPaymentPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesConfirmPaymentPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/confirm-payment`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/confirm-payment",
        method: "POST",
        operationId: "confirmPayment",
        summary: null,
        methodName: `invoicesConfirmPayment_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesConfirmPaymentPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesConfirmPaymentPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesConfirmPaymentPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesConfirmPaymentPostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesConfirmPaymentPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesConfirmPaymentPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesConfirmPaymentPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesMarkUncollectiblePostByIdV1ResponseType =
  | Readonly<{ body: null; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Set an invoice's state from either OPEN or PAYMENT_DEFERRED to UNCOLLECTIBLE
 */
export const invoicesMarkUncollectible_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesMarkUncollectiblePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesMarkUncollectiblePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/mark-uncollectible`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/mark-uncollectible",
        method: "POST",
        operationId: "markInvoiceUncollectible",
        summary: null,
        methodName: `invoicesMarkUncollectible_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 202:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesMarkUncollectiblePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesMarkUncollectiblePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesMarkUncollectiblePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesMarkUncollectiblePostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesMarkUncollectiblePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesMarkUncollectiblePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesMarkUncollectiblePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesPayPostByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: ApiError | void; status: 402; response: Omit<Response, "status"> & { status: 402 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Invoice must be in open state for attempting to pay, and this will NOT count as one of the automated retries)
 */
export const invoicesPay_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesPayPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesPayPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/pay`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/pay",
        method: "POST",
        operationId: "attemptToPay",
        summary: null,
        methodName: `invoicesPay_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 402:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesPayPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesPayPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesPayPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<InvoicesPayPostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesPayPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesPayPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesPayPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesPaymentDeferredPostByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: ApiError | void; status: 402; response: Omit<Response, "status"> & { status: 402 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Set an invoice's state from OPEN to PAYMENT_DEFERRED for PUSH payment methods only
 */
export const invoicesPaymentDeferred_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesPaymentDeferredPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesPaymentDeferredPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/payment-deferred`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/payment-deferred",
        method: "POST",
        operationId: "markPaymentDeferred",
        summary: null,
        methodName: `invoicesPaymentDeferred_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 402:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesPaymentDeferredPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesPaymentDeferredPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesPaymentDeferredPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesPaymentDeferredPostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesPaymentDeferredPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesPaymentDeferredPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesPaymentDeferredPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesRecordDunningPostByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * record dunning attempt for invoices paid via push payment methods
 */
export const invoicesRecordDunning_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: DunningAttemptInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesRecordDunningPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      DunningAttemptInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesRecordDunningPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/record-dunning`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/record-dunning",
        method: "POST",
        operationId: "recordDunningAttemptPushPayment",
        summary: null,
        methodName: `invoicesRecordDunning_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesRecordDunningPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesRecordDunningPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesRecordDunningPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesRecordDunningPostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesRecordDunningPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesRecordDunningPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesRecordDunningPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesResendEmailPostByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * Resend invoice email for an existing paid invoice to billing admins
 */
export const invoicesResendEmail_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesResendEmailPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesResendEmailPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/resend-email`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/resend-email",
        method: "POST",
        operationId: "sendEmail",
        summary: null,
        methodName: `invoicesResendEmail_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesResendEmailPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesResendEmailPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesResendEmailPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesResendEmailPostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesResendEmailPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesResendEmailPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesResendEmailPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesUserDefinedNotePostByIdV1ResponseType =
  | Readonly<{ body: InvoiceDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "invoice-resource"
 * @description
 * add user defined note aka metadata for the invoice
 */
export const invoicesUserDefinedNote_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: AddUserDefinedNotePayload;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesUserDefinedNotePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      AddUserDefinedNotePayload,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<InvoicesUserDefinedNotePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.id}/user-defined-note`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${id}/user-defined-note",
        method: "POST",
        operationId: "addUserDefinedNote",
        summary: null,
        methodName: `invoicesUserDefinedNote_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesUserDefinedNotePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesUserDefinedNotePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesUserDefinedNotePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesUserDefinedNotePostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesUserDefinedNotePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesUserDefinedNotePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesUserDefinedNotePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type InvoicesDownloadGetByInvoiceIdV1ResponseType =
  | Readonly<{ body: File; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 503;
      response: Omit<Response, "status"> & { status: 503 };
    }>;

/**
 * Tags: "Invoice Download API"
 * @summary
 * Download an invoice
 */
export const invoicesDownload_get_byInvoiceId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Invoice ID */
      invoiceId: string;
    };
    queryParameters: {
      transactionAccountId: string;
      sourceSystem?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      InvoicesDownloadGetByInvoiceIdV1ResponseType,
      {
        /** Invoice ID */
        invoiceId: string;
      },
      {
        transactionAccountId: string;
        sourceSystem?: string;
      },
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<InvoicesDownloadGetByInvoiceIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/invoices/${pathParameters.invoiceId}/download`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/invoices/${invoiceId}/download",
        method: "GET",
        operationId: "getInvoice",
        summary: "Download an invoice",
        methodName: `invoicesDownload_get_byInvoiceId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 401:
          case 500:
          case 503:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          case 200:
            return error({
              ...sharedFields,
              code: MIME_TYPE_NOT_SUPPORTED,
            } as const);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & InvoicesDownloadGetByInvoiceIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<InvoicesDownloadGetByInvoiceIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & InvoicesDownloadGetByInvoiceIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  InvoicesDownloadGetByInvoiceIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<InvoicesDownloadGetByInvoiceIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<InvoicesDownloadGetByInvoiceIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as InvoicesDownloadGetByInvoiceIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type MigrationsPaymentMethodsPostV1ResponseType =
  | Readonly<{
      body: PaymentMethodMigrationRequestDto;
      status: 202;
      response: Omit<Response, "status"> & { status: 202 };
    }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "migration-resource"
 */
export const migrationsPaymentMethods_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: MigratePaymentMethodInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      MigrationsPaymentMethodsPostV1ResponseType,
      undefined,
      undefined,
      MigratePaymentMethodInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<MigrationsPaymentMethodsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/migrations/payment-methods`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/migrations/payment-methods",
        method: "POST",
        operationId: "createPaymentMethod_1",
        summary: null,
        methodName: `migrationsPaymentMethods_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 202:
          case 400:
          case 404:
          case 409:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & MigrationsPaymentMethodsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<MigrationsPaymentMethodsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & MigrationsPaymentMethodsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  MigrationsPaymentMethodsPostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<MigrationsPaymentMethodsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<MigrationsPaymentMethodsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as MigrationsPaymentMethodsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type MigrationsTransactionAccountEventGetV1ResponseType =
  | Readonly<{ body: TransactionAccountEvent; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "migration-resource"
 * @description
 * Retrieve the transaction account event payload for a given txa id
 */
export const migrationsTransactionAccountEvent_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      MigrationsTransactionAccountEventGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<MigrationsTransactionAccountEventGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/migrations/transaction-account/event`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/migrations/transaction-account/event",
        method: "GET",
        operationId: "getTransactionAccountEvent",
        summary: null,
        methodName: `migrationsTransactionAccountEvent_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  MigrationsTransactionAccountEventGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<MigrationsTransactionAccountEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & MigrationsTransactionAccountEventGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  MigrationsTransactionAccountEventGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<MigrationsTransactionAccountEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<MigrationsTransactionAccountEventGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as MigrationsTransactionAccountEventGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingBySlugGetBySlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Slug"
 */
export const offeringBySlug_get_bySlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      slug: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingBySlugGetBySlugV1ResponseType,
      {
        slug: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingBySlugGetBySlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-by-slug/${pathParameters.slug}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-by-slug/${slug}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringBySlug_get_bySlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingBySlugGetBySlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingBySlugGetBySlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingBySlugGetBySlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingBySlugGetBySlugV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingBySlugGetBySlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingBySlugGetBySlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingBySlugGetBySlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingChangesPostV1ResponseType =
  | Readonly<{ body: OfferingChangeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Change"
 * @summary
 * Create offering change
 */
export const offeringChanges_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateOfferingChangeRequest;
    headers: {
      "X-Catalog-Account": string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingChangesPostV1ResponseType,
      undefined,
      undefined,
      CreateOfferingChangeRequest,
      {
        "X-Catalog-Account": string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingChangesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-changes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-changes",
        method: "POST",
        operationId: null,
        summary: "Create offering change",
        methodName: `offeringChanges_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingChangesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingChangesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingChangesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingChangesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingChangesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingChangesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingChangesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingChangesDeleteByOfferingChangeIdV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Change"
 * @summary
 * Delete offering change by offeringChangeId
 */
export const offeringChanges_delete_byOfferingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      offeringChangeId: string;
    };
    headers: {
      "X-Catalog-Account": string;
    };
    hooks?: RequestHooks<
      OfferingChangesDeleteByOfferingChangeIdV1ResponseType,
      {
        offeringChangeId: string;
      },
      undefined,
      undefined,
      {
        "X-Catalog-Account": string;
      }
    >;
  }): Promise<Result<OfferingChangesDeleteByOfferingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-changes/${offeringChangeId}",
        method: "DELETE",
        operationId: null,
        summary: "Delete offering change by offeringChangeId",
        methodName: `offeringChanges_delete_byOfferingChangeId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingChangesDeleteByOfferingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingChangesDeleteByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingChangesDeleteByOfferingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingChangesDeleteByOfferingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingChangesDeleteByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingChangesDeleteByOfferingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingChangesDeleteByOfferingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingChangesGetByOfferingChangeIdV1ResponseType =
  | Readonly<{ body: OfferingChangeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Change"
 * @summary
 * Get offering change by offeringChangeId
 */
export const offeringChanges_get_byOfferingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      offeringChangeId: string;
    };
    hooks?: RequestHooks<
      OfferingChangesGetByOfferingChangeIdV1ResponseType,
      {
        offeringChangeId: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<OfferingChangesGetByOfferingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-changes/${offeringChangeId}",
        method: "GET",
        operationId: null,
        summary: "Get offering change by offeringChangeId",
        methodName: `offeringChanges_get_byOfferingChangeId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingChangesGetByOfferingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingChangesGetByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingChangesGetByOfferingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingChangesGetByOfferingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingChangesGetByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingChangesGetByOfferingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingChangesGetByOfferingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingChangesPutByOfferingChangeIdV1ResponseType =
  | Readonly<{ body: OfferingChangeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Change"
 * @summary
 * Update offering change by offeringChangeId
 */
export const offeringChanges_put_byOfferingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingChangeUpdateInput;
    pathParameters: {
      offeringChangeId: string;
    };
    headers: {
      "X-Catalog-Account": string;
    };
    hooks?: RequestHooks<
      OfferingChangesPutByOfferingChangeIdV1ResponseType,
      {
        offeringChangeId: string;
      },
      undefined,
      OfferingChangeUpdateInput,
      {
        "X-Catalog-Account": string;
      }
    >;
  }): Promise<Result<OfferingChangesPutByOfferingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-changes/${offeringChangeId}",
        method: "PUT",
        operationId: null,
        summary: "Update offering change by offeringChangeId",
        methodName: `offeringChanges_put_byOfferingChangeId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingChangesPutByOfferingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingChangesPutByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingChangesPutByOfferingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingChangesPutByOfferingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingChangesPutByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingChangesPutByOfferingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingChangesPutByOfferingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType =
  | Readonly<{ body: PaginatedResponseBaseResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Change Migrations"
 */
export const offeringChangesMigrations_get_byOfferingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      offeringChangeId: string;
    };
    queryParameters?: {
      status?: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED";
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    hooks?: RequestHooks<
      OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType,
      {
        offeringChangeId: string;
      },
      | {
          status?: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED";
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offering-changes/${pathParameters.offeringChangeId}/migrations`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-changes/${offeringChangeId}/migrations",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringChangesMigrations_get_byOfferingChangeId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingChangesMigrationsGetByOfferingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipTemplatesPostV1ResponseType =
  | Readonly<{
      body: OfferingRelationshipTemplateResponse;
      status: 201;
      response: Omit<Response, "status"> & { status: 201 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 */
export const offeringRelationshipTemplates_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateOfferingRelationshipTemplateRequest;
    headers: {
      "X-Catalog-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipTemplatesPostV1ResponseType,
      undefined,
      undefined,
      CreateOfferingRelationshipTemplateRequest,
      {
        "X-Catalog-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingRelationshipTemplatesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-relationship-templates`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationship-templates",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringRelationshipTemplates_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingRelationshipTemplatesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipTemplatesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipTemplatesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipTemplatesPostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipTemplatesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipTemplatesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipTemplatesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipTemplatesGetByKeyV1ResponseType =
  | Readonly<{
      body: OfferingRelationshipTemplateResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @summary
 * Get offering relationship template by key
 */
export const offeringRelationshipTemplates_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipTemplatesGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingRelationshipTemplatesGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-relationship-templates/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationship-templates/${key}",
        method: "GET",
        operationId: null,
        summary: "Get offering relationship template by key ",
        methodName: `offeringRelationshipTemplates_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingRelationshipTemplatesGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipTemplatesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipTemplatesGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipTemplatesGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipTemplatesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipTemplatesGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipTemplatesGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType =
  | Readonly<{
      body: OfferingRelationshipTemplateResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @description
 * API to update the status of a DRAFT offering relationship template to ACTIVE
 */
export const offeringRelationshipTemplatesStatusActivate_put_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers: {
      "X-Catalog-Account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      {
        "X-Catalog-Account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offering-relationship-templates/${pathParameters.key}/status/activate`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationship-templates/${key}/status/activate",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `offeringRelationshipTemplatesStatusActivate_put_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipTemplatesStatusActivatePutByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipsGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingRelationshipResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @summary
 * Get offering relationships by offeringKey, type and/or mode
 */
export const offeringRelationships_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      /** Offering Key */
      offeringKey: string;
      /** Relationship type */
      type?: "APP_DEPENDENCE" | "APP_COMPATIBILITY" | "FAMILY_CONTAINER" | "SANDBOX_DEPENDENCE" | "SANDBOX_GRANT";
      /** Relationship mode */
      required?: boolean;
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipsGetV1ResponseType,
      undefined,
      {
        /** Offering Key */
        offeringKey: string;
        /** Relationship type */
        type?: "APP_DEPENDENCE" | "APP_COMPATIBILITY" | "FAMILY_CONTAINER" | "SANDBOX_DEPENDENCE" | "SANDBOX_GRANT";
        /** Relationship mode */
        required?: boolean;
        /**
         * Pagination size
         * @format int32
         * @min 1
         * @max 50
         * @default 10
         */
        pageSize?: number;
        /** Pagination offset cursor */
        startId?: string;
      },
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingRelationshipsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-relationships`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationships",
        method: "GET",
        operationId: null,
        summary: "Get offering relationships by offeringKey, type and/or mode",
        methodName: `offeringRelationships_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingRelationshipsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingRelationshipsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipsBulkFetchGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingRelationshipResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @summary
 * Get all offering Relationships
 */
export const offeringRelationshipsBulkFetch_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipsBulkFetchGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<OfferingRelationshipsBulkFetchGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-relationships/bulk-fetch`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationships/bulk-fetch",
        method: "GET",
        operationId: null,
        summary: "Get all offering Relationships",
        methodName: `offeringRelationshipsBulkFetch_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingRelationshipsBulkFetchGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipsBulkFetchGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipsBulkFetchGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipsBulkFetchGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipsBulkFetchGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipsBulkFetchGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipsBulkFetchGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipsGetByKeyV1ResponseType =
  | Readonly<{ body: OfferingRelationshipResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @summary
 * Get offering relationship  by key
 */
export const offeringRelationships_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipsGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingRelationshipsGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offering-relationships/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationships/${key}",
        method: "GET",
        operationId: null,
        summary: "Get offering relationship  by key",
        methodName: `offeringRelationships_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingRelationshipsGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipsGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipsGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipsGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipsGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingRelationshipResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering Relationship Template"
 * @summary
 * Get offering relationship by offering key and set of comma separated related keys
 */
export const offeringRelationshipsMeaningful_get_byOfferingKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Offering Key */
      offeringKey: string;
    };
    queryParameters?: {
      /** Related Keys */
      relatedOfferingKeys?: string;
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType,
      {
        /** Offering Key */
        offeringKey: string;
      },
      | {
          /** Related Keys */
          relatedOfferingKeys?: string;
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offering-relationships/${pathParameters.offeringKey}/meaningful`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offering-relationships/${offeringKey}/meaningful",
        method: "GET",
        operationId: null,
        summary: "Get offering relationship by offering key and set of comma separated related keys ",
        methodName: `offeringRelationshipsMeaningful_get_byOfferingKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingRelationshipsMeaningfulGetByOfferingKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    hooks?: RequestHooks<
      OfferingsGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      undefined
    >;
  } = {}): Promise<Result<OfferingsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offerings_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPostV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingInput;
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPostV1ResponseType,
      undefined,
      undefined,
      OfferingInput,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offerings_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsFetchBatchPostV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Fetch multiple offerings with the limit of 10 at a time
 */
export const offeringsFetchBatch_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1OfferingsFetchBatchCreatePayload;
    hooks?: RequestHooks<
      OfferingsFetchBatchPostV1ResponseType,
      undefined,
      undefined,
      V1OfferingsFetchBatchCreatePayload,
      undefined
    >;
  }): Promise<Result<OfferingsFetchBatchPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/fetch-batch`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/fetch-batch",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsFetchBatch_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsFetchBatchPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsFetchBatchPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsFetchBatchPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsFetchBatchPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsFetchBatchPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @summary
 * Delete extension
 */
export const offeringsExtensions_delete_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
        method: "DELETE",
        operationId: null,
        summary: "Delete extension",
        methodName: `offeringsExtensions_delete_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @summary
 * Get extension
 */
export const offeringsExtensions_get_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
        method: "GET",
        operationId: null,
        summary: "Get extension",
        methodName: `offeringsExtensions_get_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @summary
 * Create/Update extensions
 */
export const offeringsExtensions_put_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateEntityExtensionDataInput;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      UpdateEntityExtensionDataInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
        method: "PUT",
        operationId: null,
        summary: "Create/Update extensions",
        methodName: `offeringsExtensions_put_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType =
  | Readonly<{ body: EntitlementTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsLatestEntitlementTemplate_get_byKeyOrSLug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSLug: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType,
      {
        keyOrSLug: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSLug}/latest-entitlement-template`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSLug}/latest-entitlement-template",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsLatestEntitlementTemplate_get_byKeyOrSLug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsLatestEntitlementTemplateGetByKeyOrSLugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDeleteByKeyOrSlugV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Delete an offering
 */
export const offerings_delete_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsDeleteByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsDeleteByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `offerings_delete_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsDeleteByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsDeleteByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDeleteByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsDeleteByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDeleteByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsGetByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    hooks?: RequestHooks<
      OfferingsGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<OfferingsGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offerings_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPatchByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Patch update offering attributes (Name, Level, OfferingGroup, trial, slugs, etc).
 */
export const offerings_patch_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingPatchUpdateInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPatchByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      OfferingPatchUpdateInput,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsPatchByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}",
        method: "PATCH",
        operationId: null,
        summary: null,
        methodName: `offerings_patch_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsPatchByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPatchByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPatchByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsPatchByKeyOrSlugV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPatchByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPatchByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPatchByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPutByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Update offering attributes (Name, Level, OfferingGroup).
 */
export const offerings_put_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingUpdateInput;
    pathParameters: {
      keyOrSlug: string;
    };
    hooks?: RequestHooks<
      OfferingsPutByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      OfferingUpdateInput,
      undefined
    >;
  }): Promise<Result<OfferingsPutByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `offerings_put_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsPutByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPutByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPutByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsPutByKeyOrSlugV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPutByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPutByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPutByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsActivationPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Actives an offering in DRAFT state
 */
export const offeringsActivation_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsActivationPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsActivationPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/activation`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/activation",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsActivation_post_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsActivationPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsActivationPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsActivationPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsActivationPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsActivationPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsActivationPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsActivationPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsChildrenGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * List paginated children offerings (add-ons) available for the provided offering
 */
export const offeringsChildren_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsChildrenGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      | {
          /**
           * Pagination size
           * @format int32
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsChildrenGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/children`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/children",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsChildren_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsChildrenGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsChildrenGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsChildrenGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsChildrenGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsChildrenGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsChildrenGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsChildrenGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Remove all depends-on offerings
 */
export const offeringsDependsOnOfferings_delete_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDependsOnOfferingsDeleteByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Add new depends-on offerings
 */
export const offeringsDependsOnOfferings_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: DependsOnOfferingInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      DependsOnOfferingInput,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsDependsOnOfferings_post_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDependsOnOfferingsPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Replace all depends-on offerings
 */
export const offeringsDependsOnOfferings_put_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: DependsOnOfferingInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      DependsOnOfferingInput,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `offeringsDependsOnOfferings_put_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDependsOnOfferingsPutByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Remove a specific depends-on offering
 */
export const offeringsDependsOnOfferings_delete_byKeyOrSlugAndDependsOnKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
      dependsOnKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
    };
    hooks?: RequestHooks<
      OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType,
      {
        keyOrSlug: string;
        dependsOnKey: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings/${pathParameters.dependsOnKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings/${dependsOnKey}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlugAndDependsOnKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDependsOnOfferingsDeleteByKeyOrSlugAndDependsOnKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: EntitlementTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsEntitlementTemplates_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: EntitlementTemplateInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      EntitlementTemplateInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/entitlement-templates`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/entitlement-templates",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsEntitlementTemplates_post_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsEntitlementTemplatesPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPricingChangesGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: PaginatedResponsePricingChangeResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * List all pricing changes for a offering
 */
export const offeringsPricingChanges_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    queryParameters?: {
      /**
       * Pagination Size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPricingChangesGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      | {
          /**
           * Pagination Size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsPricingChangesGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/pricing-changes`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/pricing-changes",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsPricingChanges_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsPricingChangesGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPricingChangesGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPricingChangesGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsPricingChangesGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPricingChangesGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPricingChangesGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPricingChangesGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: PaginatedResponsePricingPlanResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * List pricing plans that a specified offering (not PAID) is allowed to transition to. Only transitions inside the same product are evaluated.
 */
export const offeringsPricingPlanTransitions_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    queryParameters?: {
      /** currency ISO-4217 code */
      currency?: "USD" | "JPY";
      /** cycle name (MONTHLY, ANNUAL) */
      cycle?: "MONTHLY" | "ANNUAL";
      /** type COMMERCIAL or as defined per synthetic templates */
      type?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      | {
          /** currency ISO-4217 code */
          currency?: "USD" | "JPY";
          /** cycle name (MONTHLY, ANNUAL) */
          cycle?: "MONTHLY" | "ANNUAL";
          /** type COMMERCIAL or as defined per synthetic templates */
          type?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plan-transitions`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/pricing-plan-transitions",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsPricingPlanTransitions_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPricingPlanTransitionsGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPricingPlansGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: PaginatedResponsePricingPlanResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * List all pricing plans under the provided offering key
 */
export const offeringsPricingPlans_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    queryParameters?: {
      /** currency ISO-4217 code */
      currency?: "USD" | "JPY";
      /** cycle name (MONTHLY, ANNUAL) */
      cycle?: "MONTHLY" | "ANNUAL";
      /** type COMMERCIAL or as defined per synthetic templates */
      type?: string;
      /** flag to filter default pricing plans */
      queryDefaultPricingPlans?: boolean;
      /** pricing plans status(DRAFT, ACTIVE, AT_NOTICE, EXPIRED) */
      status?: "NONE" | "DRAFT" | "ACTIVE" | "AT_NOTICE" | "EXPIRED";
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPricingPlansGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      | {
          /** currency ISO-4217 code */
          currency?: "USD" | "JPY";
          /** cycle name (MONTHLY, ANNUAL) */
          cycle?: "MONTHLY" | "ANNUAL";
          /** type COMMERCIAL or as defined per synthetic templates */
          type?: string;
          /** flag to filter default pricing plans */
          queryDefaultPricingPlans?: boolean;
          /** pricing plans status(DRAFT, ACTIVE, AT_NOTICE, EXPIRED) */
          status?: "NONE" | "DRAFT" | "ACTIVE" | "AT_NOTICE" | "EXPIRED";
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsPricingPlansGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plans`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/pricing-plans",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsPricingPlans_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsPricingPlansGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPricingPlansGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPricingPlansGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsPricingPlansGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPricingPlansGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPricingPlansGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPricingPlansGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSlugsPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: OfferingDetailsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Adds slugs to offering.
 */
export const offeringsSlugs_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingSlugsInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSlugsPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      OfferingSlugsInput,
      | {
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSlugsPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/slugs`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/slugs",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsSlugs_post_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsSlugsPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSlugsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSlugsPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSlugsPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSlugsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsSlugsPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSlugsPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSyntheticsGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: SyntheticPlanTemplateResponse[];
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsSynthetics_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSyntheticsGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSyntheticsGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/synthetics",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsSynthetics_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsSyntheticsGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSyntheticsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSyntheticsGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSyntheticsGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSyntheticsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsSyntheticsGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSyntheticsGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSyntheticsPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: SyntheticPlanTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsSynthetics_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: SyntheticPlanTemplateInput;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSyntheticsPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      SyntheticPlanTemplateInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSyntheticsPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/synthetics",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsSynthetics_post_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsSyntheticsPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSyntheticsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSyntheticsPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSyntheticsPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSyntheticsPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsSyntheticsPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSyntheticsPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType =
  | Readonly<{ body: null; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsSynthetics_delete_byKeyOrSlugAndTemplateType_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
      templateType: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType,
      {
        keyOrSlug: string;
        templateType: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `offeringsSynthetics_delete_byKeyOrSlugAndTemplateType_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 200:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSyntheticsDeleteByKeyOrSlugAndTemplateTypeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType =
  | Readonly<{ body: SyntheticPlanTemplateResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsSynthetics_put_byKeyOrSlugAndTemplateType_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: SyntheticPlanTemplateUpdatableFieldsInput;
    pathParameters: {
      keyOrSlug: string;
      templateType: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType,
      {
        keyOrSlug: string;
        templateType: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
      },
      undefined,
      SyntheticPlanTemplateUpdatableFieldsInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `offeringsSynthetics_put_byKeyOrSlugAndTemplateType_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSyntheticsPutByKeyOrSlugAndTemplateTypeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType =
  | Readonly<{ body: PricingPlanResponse[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsSyntheticsGenerate_post_byKeyOrSlugAndType_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1OfferingsSyntheticsGenerateCreatePayload;
    pathParameters: {
      keyOrSlug: string;
      type: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType,
      {
        keyOrSlug: string;
        type: "COMMUNITY" | "OPEN_SOURCE" | "CLASSROOM" | "ACADEMIC" | "FOUNDATION_FREE";
      },
      undefined,
      V1OfferingsSyntheticsGenerateCreatePayload,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.type}/generate`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/synthetics/${type}/generate",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsSyntheticsGenerate_post_byKeyOrSlugAndType_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsSyntheticsGeneratePostByKeyOrSlugAndTypeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsTransitionsGetByKeyOrSlugV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingV2Response;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * List offerings that the specified offering is allowed to transition to. Only transitions inside the same product are evaluated.
 */
export const offeringsTransitions_get_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsTransitionsGetByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsTransitionsGetByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/transitions`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/transitions",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsTransitions_get_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsTransitionsGetByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsTransitionsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsTransitionsGetByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsTransitionsGetByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsTransitionsGetByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsTransitionsGetByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsTransitionsGetByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsTrialDeleteByKeyOrSlugV1ResponseType =
  | Readonly<{ body: null; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsTrial_delete_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      keyOrSlug: string;
    };
    hooks?: RequestHooks<
      OfferingsTrialDeleteByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<OfferingsTrialDeleteByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/trial",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `offeringsTrial_delete_byKeyOrSlug_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 200:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsTrialDeleteByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsTrialDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsTrialDeleteByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsTrialDeleteByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsTrialDeleteByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsTrialDeleteByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsTrialDeleteByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsTrialPostByKeyOrSlugV1ResponseType =
  | Readonly<{ body: TrialResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsTrial_post_byKeyOrSlug_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: TrialInput;
    pathParameters: {
      keyOrSlug: string;
    };
    hooks?: RequestHooks<
      OfferingsTrialPostByKeyOrSlugV1ResponseType,
      {
        keyOrSlug: string;
      },
      undefined,
      TrialInput,
      undefined
    >;
  }): Promise<Result<OfferingsTrialPostByKeyOrSlugV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/offerings/${keyOrSlug}/trial",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsTrial_post_byKeyOrSlug_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsTrialPostByKeyOrSlugV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsTrialPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsTrialPostByKeyOrSlugV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsTrialPostByKeyOrSlugV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsTrialPostByKeyOrSlugV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsTrialPostByKeyOrSlugV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsTrialPostByKeyOrSlugV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderDefaultsGetByOfferingIdV1ResponseType =
  | Readonly<{ body: OrderDefault; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 412; response: Omit<Response, "status"> & { status: 412 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>
  | Readonly<{ body: ApiGatewayErrorResponse; status: 503; response: Omit<Response, "status"> & { status: 503 } }>;

/**
 * Tags: "Order Default Api"
 * @summary
 * Get order default
 */
export const orderDefaults_get_byOfferingId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Offering Id */
      offeringId: string;
    };
    queryParameters?: {
      /** Current EntitlementId Id */
      currentEntitlementId?: string;
      relatedEntitlementId?: string;
      relationshipType?: "APP_DEPENDENCE" | "FAMILY_CONTAINER" | "SANDBOX_DEPENDENCE";
      billingCycle?: "MONTHLY" | "ANNUAL";
      paymentMethodType?: "CARD" | "DEFERRED";
      shipToPartyId?: string;
      purchaseOrderNumber?: string;
    };
    headers?: {
      "X-Transaction-Account"?: string;
      /** Transaction account (X-Transaction-Account) is mandatory to get order default response for SCT use cases */
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrderDefaultsGetByOfferingIdV1ResponseType,
      {
        /** Offering Id */
        offeringId: string;
      },
      | {
          /** Current EntitlementId Id */
          currentEntitlementId?: string;
          relatedEntitlementId?: string;
          relationshipType?: "APP_DEPENDENCE" | "FAMILY_CONTAINER" | "SANDBOX_DEPENDENCE";
          billingCycle?: "MONTHLY" | "ANNUAL";
          paymentMethodType?: "CARD" | "DEFERRED";
          shipToPartyId?: string;
          purchaseOrderNumber?: string;
        }
      | undefined,
      undefined,
      | {
          "X-Transaction-Account"?: string;
          /** Transaction account (X-Transaction-Account) is mandatory to get order default response for SCT use cases */
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OrderDefaultsGetByOfferingIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/order-defaults/${pathParameters.offeringId}`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/order-defaults/${offeringId}",
        method: "GET",
        operationId: "getOrderDefault",
        summary: "Get order default",
        methodName: `orderDefaults_get_byOfferingId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 412:
          case 500:
          case 503:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderDefaultsGetByOfferingIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderDefaultsGetByOfferingIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderDefaultsGetByOfferingIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OrderDefaultsGetByOfferingIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderDefaultsGetByOfferingIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderDefaultsGetByOfferingIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderDefaultsGetByOfferingIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderIntentPostV1ResponseType =
  | Readonly<{ body: OrderIntentResponseDto; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-intent-resource"
 * @summary
 * Create Order Intent
 */
export const orderIntent_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1OrderIntentCreatePayload;
    queryParameters?: {
      /** @default "v1" */
      errorResponseVersion?: "v1" | "v2";
    };
    headers?: {
      "X-transaction-account"?: string;
      "X-CCP-Context"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
    };
    hooks?: RequestHooks<
      OrderIntentPostV1ResponseType,
      undefined,
      | {
          /** @default "v1" */
          errorResponseVersion?: "v1" | "v2";
        }
      | undefined,
      V1OrderIntentCreatePayload,
      | {
          "X-transaction-account"?: string;
          "X-CCP-Context"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
          "X-Slauth-Subject"?: string;
          "X-Slauth-Mechanism"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OrderIntentPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderIntent`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderIntent",
        method: "POST",
        operationId: null,
        summary: "Create Order Intent",
        methodName: `orderIntent_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderIntentPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderIntentPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderIntentPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderIntentPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderIntentPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderIntentPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderIntentPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderIntentEstimatePostV1ResponseType =
  | Readonly<{ body: OrderBillEstimateResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-intent-resource"
 * @summary
 * Get Bill Estimate for Order
 */
export const orderIntentEstimate_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OrderIntentWithOrderItemsLegacyWebRequestDto;
    queryParameters?: {
      /** @default "v1" */
      errorResponseVersion?: "v1" | "v2";
    };
    headers?: {
      "X-transaction-account"?: string;
      "X-CCP-Context"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
    };
    hooks?: RequestHooks<
      OrderIntentEstimatePostV1ResponseType,
      undefined,
      | {
          /** @default "v1" */
          errorResponseVersion?: "v1" | "v2";
        }
      | undefined,
      OrderIntentWithOrderItemsLegacyWebRequestDto,
      | {
          "X-transaction-account"?: string;
          "X-CCP-Context"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
          "X-Slauth-Subject"?: string;
          "X-Slauth-Mechanism"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OrderIntentEstimatePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderIntent/estimate`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderIntent/estimate",
        method: "POST",
        operationId: null,
        summary: "Get Bill Estimate for Order",
        methodName: `orderIntentEstimate_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderIntentEstimatePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderIntentEstimatePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderIntentEstimatePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderIntentEstimatePostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderIntentEstimatePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderIntentEstimatePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderIntentEstimatePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderIntentPreviewPostV1ResponseType =
  | Readonly<{ body: OrderGetResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-intent-resource"
 * @summary
 * Preview Order
 */
export const orderIntentPreview_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1OrderIntentPreviewCreatePayload;
    queryParameters?: {
      /** @default "v1" */
      errorResponseVersion?: "v1" | "v2";
    };
    headers?: {
      "X-transaction-account"?: string;
      "X-CCP-Context"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
    };
    hooks?: RequestHooks<
      OrderIntentPreviewPostV1ResponseType,
      undefined,
      | {
          /** @default "v1" */
          errorResponseVersion?: "v1" | "v2";
        }
      | undefined,
      V1OrderIntentPreviewCreatePayload,
      | {
          "X-transaction-account"?: string;
          "X-CCP-Context"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
          "X-Slauth-Subject"?: string;
          "X-Slauth-Mechanism"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OrderIntentPreviewPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderIntent/preview`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderIntent/preview",
        method: "POST",
        operationId: null,
        summary: "Preview Order",
        methodName: `orderIntentPreview_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderIntentPreviewPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderIntentPreviewPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderIntentPreviewPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderIntentPreviewPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderIntentPreviewPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderIntentPreviewPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderIntentPreviewPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderIntentGetByIdV1ResponseType =
  | Readonly<{ body: OrderIntentGetResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-intent-resource"
 * @summary
 * Get order intent by id
 */
export const orderIntent_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-transaction-account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrderIntentGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        "X-transaction-account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrderIntentGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderIntent/${id}",
        method: "GET",
        operationId: null,
        summary: "Get order intent by id",
        methodName: `orderIntent_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderIntentGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderIntentGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderIntentGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderIntentGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderIntentGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderIntentGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderIntentGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderIntentPatchByIdV1ResponseType =
  | Readonly<{ body: null; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-intent-resource"
 * @summary
 * Update status of order intent by id
 */
export const orderIntent_patch_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: JsonPatch;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-transaction-account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrderIntentPatchByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      JsonPatch,
      {
        "X-transaction-account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrderIntentPatchByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderIntent/${id}",
        method: "PATCH",
        operationId: null,
        summary: "Update status of order intent by id",
        methodName: `orderIntent_patch_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          case 200:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderIntentPatchByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderIntentPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderIntentPatchByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderIntentPatchByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderIntentPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderIntentPatchByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderIntentPatchByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType =
  | Readonly<{ body: RewindToDetailsResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-item-resource"
 * @summary
 * Get RewindToDetails From OrderItemId
 */
export const orderItemRewindToDetails_get_byOrderItemId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      orderItemId: string;
    };
    headers: {
      "X-transaction-account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType,
      {
        orderItemId: string;
      },
      undefined,
      undefined,
      {
        "X-transaction-account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderItem/${pathParameters.orderItemId}/rewindToDetails`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderItem/${orderItemId}/rewindToDetails",
        method: "GET",
        operationId: null,
        summary: "Get RewindToDetails From OrderItemId",
        methodName: `orderItemRewindToDetails_get_byOrderItemId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderItemRewindToDetailsGetByOrderItemIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrderItemsGetV1ResponseType =
  | Readonly<{ body: PaginatedOrderItemResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-item-resource"
 * @summary
 * Get order by entitlement id
 */
export const orderItems_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      /** EntitlementId */
      entitlementId: string;
      /**
       * Pagination size
       * @format int32
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
      /** OrderItemId */
      orderItemId?: string;
    };
    headers: {
      "X-transaction-account": string;
      "X-Slauth-Subject"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrderItemsGetV1ResponseType,
      undefined,
      {
        /** EntitlementId */
        entitlementId: string;
        /**
         * Pagination size
         * @format int32
         * @default 10
         */
        pageSize?: number;
        /** Pagination offset cursor */
        startId?: string;
        /** OrderItemId */
        orderItemId?: string;
      },
      undefined,
      {
        "X-transaction-account": string;
        "X-Slauth-Subject"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrderItemsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orderItems`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orderItems",
        method: "GET",
        operationId: null,
        summary: "Get order by entitlement id",
        methodName: `orderItems_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrderItemsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrderItemsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrderItemsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrderItemsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrderItemsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrderItemsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrderItemsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrdersPostV1ResponseType =
  | Readonly<{ body: OrderResponseDto; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-resource"
 * @summary
 * Create order
 */
export const orders_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1OrdersCreateBody;
    queryParameters?: {
      /** @default "v1" */
      errorResponseVersion?: "v1" | "v2";
    };
    headers: {
      "X-transaction-account": string;
      "X-CCP-Context"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
    };
    hooks?: RequestHooks<
      OrdersPostV1ResponseType,
      undefined,
      | {
          /** @default "v1" */
          errorResponseVersion?: "v1" | "v2";
        }
      | undefined,
      V1OrdersCreateBody,
      {
        "X-transaction-account": string;
        "X-CCP-Context"?: string;
        "User-Context"?: string;
        "Staff-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
      }
    >;
  }): Promise<Result<OrdersPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orders`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orders",
        method: "POST",
        operationId: null,
        summary: "Create order",
        methodName: `orders_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrdersPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrdersPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrdersPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrdersPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrdersPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrdersPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrdersPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrdersGetByIdV1ResponseType =
  | Readonly<{ body: OrderGetResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-resource"
 * @summary
 * Get order by id
 */
export const orders_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-transaction-account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrdersGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        "X-transaction-account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrdersGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/orders/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orders/${id}",
        method: "GET",
        operationId: null,
        summary: "Get order by id",
        methodName: `orders_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OrdersGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrdersGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrdersGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OrdersGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrdersGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrdersGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrdersGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType =
  | Readonly<{ body: OrderGetResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 405;
      response: Omit<Response, "status"> & { status: 405 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 409;
      response: Omit<Response, "status"> & { status: 409 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 415;
      response: Omit<Response, "status"> & { status: 415 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 422;
      response: Omit<Response, "status"> & { status: 422 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 423;
      response: Omit<Response, "status"> & { status: 423 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: OrderServiceValidationErrorResponse;
      status: 501;
      response: Omit<Response, "status"> & { status: 501 };
    }>;

/**
 * Tags: "order-item-resource"
 * @summary
 * Get order by order item id
 */
export const ordersOrderItem_get_byOrderIdAndOrderItemId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      orderId: string;
      orderItemId: string;
    };
    headers: {
      "X-transaction-account": string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType,
      {
        orderId: string;
        orderItemId: string;
      },
      undefined,
      undefined,
      {
        "X-transaction-account": string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/orders/${pathParameters.orderId}/orderItem/${pathParameters.orderItemId}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/orders/${orderId}/orderItem/${orderItemId}",
        method: "GET",
        operationId: null,
        summary: "Get order by order item id",
        methodName: `ordersOrderItem_get_byOrderIdAndOrderItemId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 404:
          case 405:
          case 409:
          case 415:
          case 422:
          case 423:
          case 500:
          case 501:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OrdersOrderItemGetByOrderIdAndOrderItemIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType =
  | Readonly<{ body: EntitlementSummary; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 400;
      response: Omit<Response, "status"> & { status: 400 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 401;
      response: Omit<Response, "status"> & { status: 401 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 404;
      response: Omit<Response, "status"> & { status: 404 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 500;
      response: Omit<Response, "status"> & { status: 500 };
    }>
  | Readonly<{
      body: void | ApiGatewayErrorResponse;
      status: 503;
      response: Omit<Response, "status"> & { status: 503 };
    }>;

/**
 * Tags: "Entitlement Summary API"
 * @summary
 * Get summary of an entitlement for partners
 */
export const partnerAcquisitionsEntitlements_get_byEntitlementId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** Entitlement ID */
      entitlementId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType,
      {
        /** Entitlement ID */
        entitlementId: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/partner-acquisitions/entitlements/${pathParameters.entitlementId}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/partner-acquisitions/entitlements/${entitlementId}",
        method: "GET",
        operationId: "getEntitlementSummary",
        summary: "Get summary of an entitlement for partners",
        methodName: `partnerAcquisitionsEntitlements_get_byEntitlementId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 401:
          case 500:
          case 503:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PartnerAcquisitionsEntitlementsGetByEntitlementIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PartnerStatusGetV1ResponseType =
  | Readonly<{ body: PartnerStatusDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "partner-status-resource"
 * @description
 * Retrieve the partner info
 */
export const partnerStatus_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** User Context */
      "User-Context"?: string;
      "X-transaction-account": string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PartnerStatusGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** User Context */
        "User-Context"?: string;
        "X-transaction-account": string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PartnerStatusGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/partner-status`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/partner-status",
        method: "GET",
        operationId: "getPartnerStatus",
        summary: null,
        methodName: `partnerStatus_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PartnerStatusGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PartnerStatusGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PartnerStatusGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PartnerStatusGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PartnerStatusGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PartnerStatusGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PartnerStatusGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsGetV1ResponseType =
  | Readonly<{ body: PagedListPaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * Retrieve n payment methods of the transaction account
 */
export const paymentMethods_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsGetV1ResponseType,
      undefined,
      {
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods",
        method: "GET",
        operationId: "getPaymentMethods",
        summary: null,
        methodName: `paymentMethods_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PaymentMethodsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsPostV1ResponseType =
  | Readonly<{ body: PaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * To create a payment method.
 */
export const paymentMethods_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PaymentMethodInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** @default "" */
      "Idempotency-key"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsPostV1ResponseType,
      undefined,
      undefined,
      PaymentMethodInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** @default "" */
        "Idempotency-key"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods",
        method: "POST",
        operationId: "createPaymentMethod",
        summary: null,
        methodName: `paymentMethods_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PaymentMethodsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsDeleteByIdV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * Delete payment method by id. If set as a default payment method in an invoice group/txa, it will be unset.
 */
export const paymentMethods_delete_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsDeleteByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsDeleteByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods/${id}",
        method: "DELETE",
        operationId: "deletePaymentMethod",
        summary: null,
        methodName: `paymentMethods_delete_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 204:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsDeleteByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsDeleteByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsDeleteByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PaymentMethodsDeleteByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsDeleteByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsDeleteByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsDeleteByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsGetByIdV1ResponseType =
  | Readonly<{ body: PaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * Retrieve the payment method by id
 */
export const paymentMethods_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods/${id}",
        method: "GET",
        operationId: "getPaymentMethod",
        summary: null,
        methodName: `paymentMethods_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PaymentMethodsGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsPatchByIdV1ResponseType =
  | Readonly<{ body: PaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * update payment method for push payments
 */
export const paymentMethods_patch_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PatchPaymentMethodInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsPatchByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      PatchPaymentMethodInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsPatchByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods/${id}",
        method: "PATCH",
        operationId: "updateDeferredPaymentMethod",
        summary: null,
        methodName: `paymentMethods_patch_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsPatchByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsPatchByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PaymentMethodsPatchByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsPatchByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsPatchByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsDeletePostByIdV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * Delete payment method by id. If set as a default payment method in an invoice group/txa, it will be unset. Allows to have an optional request body of metadata. e.g 'metadata': {'ticketNum': 'CA-100'}
 */
export const paymentMethodsDelete_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: DeletePaymentMethodInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsDeletePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      DeletePaymentMethodInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsDeletePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods/${pathParameters.id}/delete`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods/${id}/delete",
        method: "POST",
        operationId: "deletePaymentMethodV2",
        summary: null,
        methodName: `paymentMethodsDelete_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 204:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsDeletePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsDeletePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsDeletePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PaymentMethodsDeletePostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsDeletePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsDeletePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsDeletePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PaymentMethodsSetDefaultPutByIdV1ResponseType =
  | Readonly<{ body: PaymentMethodDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "payment-method-resource"
 * @description
 * Set default payment method for a transaction account
 */
export const paymentMethodsSetDefault_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PaymentMethodsSetDefaultPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PaymentMethodsSetDefaultPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/payment-methods/${pathParameters.id}/set-default`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/payment-methods/${id}/set-default",
        method: "PUT",
        operationId: "setDefault",
        summary: null,
        methodName: `paymentMethodsSetDefault_put_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PaymentMethodsSetDefaultPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PaymentMethodsSetDefaultPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PaymentMethodsSetDefaultPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PaymentMethodsSetDefaultPutByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PaymentMethodsSetDefaultPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PaymentMethodsSetDefaultPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PaymentMethodsSetDefaultPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingChangesPostV1ResponseType =
  | Readonly<{ body: PricingChangeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Change"
 */
export const pricingChanges_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PricingChangeInput;
    headers: {
      "X-Catalog-Account": string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingChangesPostV1ResponseType,
      undefined,
      undefined,
      PricingChangeInput,
      {
        "X-Catalog-Account": string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<PricingChangesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-changes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-changes",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `pricingChanges_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingChangesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingChangesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingChangesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingChangesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingChangesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingChangesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingChangesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingChangesPutByIdV1ResponseType =
  | Readonly<{ body: PricingChangeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Change"
 */
export const pricingChanges_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PricingChangeUpdateInput;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Catalog-Account": string;
    };
    hooks?: RequestHooks<
      PricingChangesPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      PricingChangeUpdateInput,
      {
        "X-Catalog-Account": string;
      }
    >;
  }): Promise<Result<PricingChangesPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-changes/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-changes/${id}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `pricingChanges_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingChangesPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingChangesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingChangesPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingChangesPutByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingChangesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingChangesPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingChangesPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingChangesDeleteByPricingChangeIdV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Change"
 */
export const pricingChanges_delete_byPricingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      pricingChangeId: string;
    };
    headers: {
      "X-Catalog-Account": string;
    };
    hooks?: RequestHooks<
      PricingChangesDeleteByPricingChangeIdV1ResponseType,
      {
        pricingChangeId: string;
      },
      undefined,
      undefined,
      {
        "X-Catalog-Account": string;
      }
    >;
  }): Promise<Result<PricingChangesDeleteByPricingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-changes/${pathParameters.pricingChangeId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-changes/${pricingChangeId}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `pricingChanges_delete_byPricingChangeId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PricingChangesDeleteByPricingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingChangesDeleteByPricingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingChangesDeleteByPricingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingChangesDeleteByPricingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingChangesDeleteByPricingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingChangesDeleteByPricingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingChangesDeleteByPricingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingChangesMigrationsGetByPricingChangeIdV1ResponseType =
  | Readonly<{
      body: PaginatedResponseMigrationResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Change"
 */
export const pricingChangesMigrations_get_byPricingChangeId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      pricingChangeId: string;
    };
    queryParameters?: {
      status?: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED";
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingChangesMigrationsGetByPricingChangeIdV1ResponseType,
      {
        pricingChangeId: string;
      },
      | {
          status?: "PENDING" | "PROCESSING" | "COMPLETED" | "FAILED" | "CANCELLED";
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingChangesMigrationsGetByPricingChangeIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/pricing-changes/${pathParameters.pricingChangeId}/migrations`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-changes/${pricingChangeId}/migrations",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `pricingChangesMigrations_get_byPricingChangeId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PricingChangesMigrationsGetByPricingChangeIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingChangesMigrationsGetByPricingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingChangesMigrationsGetByPricingChangeIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingChangesMigrationsGetByPricingChangeIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingChangesMigrationsGetByPricingChangeIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingChangesMigrationsGetByPricingChangeIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingChangesMigrationsGetByPricingChangeIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponsePricingPlanResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * List all pricing plans
 */
export const pricingPlans_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<PricingPlansGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `pricingPlans_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansPostV1ResponseType =
  | Readonly<{ body: PricingPlanResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 */
export const pricingPlans_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PricingPlanInput;
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansPostV1ResponseType,
      undefined,
      undefined,
      PricingPlanInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `pricingPlans_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansEventGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseInputEventPayload;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * List all pricing plans in event schema
 */
export const pricingPlansEvent_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansEventGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<PricingPlansEventGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/event`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/event",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `pricingPlansEvent_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansEventGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansEventGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansEventGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansEventGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansEventGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansFetchBatchPostV1ResponseType =
  | Readonly<{ body: PricingPlanResponse[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * Fetch multiple pricing plans with the limit of 25 at a time
 */
export const pricingPlansFetchBatch_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1PricingPlansFetchBatchCreatePayload;
    headers?: {
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansFetchBatchPostV1ResponseType,
      undefined,
      undefined,
      V1PricingPlansFetchBatchCreatePayload,
      | {
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansFetchBatchPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/fetch-batch`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/fetch-batch",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `pricingPlansFetchBatch_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansFetchBatchPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansFetchBatchPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingPlansFetchBatchPostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansFetchBatchPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansFetchBatchPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @summary
 * Delete extension
 */
export const pricingPlansExtensions_delete_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
        method: "DELETE",
        operationId: null,
        summary: "Delete extension",
        methodName: `pricingPlansExtensions_delete_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @summary
 * Get extension
 */
export const pricingPlansExtensions_get_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
        method: "GET",
        operationId: null,
        summary: "Get extension",
        methodName: `pricingPlansExtensions_get_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @summary
 * Create/Update extensions
 */
export const pricingPlansExtensions_put_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateEntityExtensionDataInput;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      UpdateEntityExtensionDataInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
        method: "PUT",
        operationId: null,
        summary: "Create/Update extensions",
        methodName: `pricingPlansExtensions_put_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansDeleteByKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * Delete a pricing plan
 */
export const pricingPlans_delete_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansDeleteByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansDeleteByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${key}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `pricingPlans_delete_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansDeleteByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansDeleteByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansDeleteByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansDeleteByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansDeleteByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansGetByKeyV1ResponseType =
  | Readonly<{ body: PricingPlanResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 */
export const pricingPlans_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${key}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `pricingPlans_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansGetByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansPutByKeyV1ResponseType =
  | Readonly<{ body: PricingPlanResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * Updates the pricing plan which are in draft state
 */
export const pricingPlans_put_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PricingPlanUpdateInput;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansPutByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      PricingPlanUpdateInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansPutByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${key}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `pricingPlans_put_byKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansPutByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansPutByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PricingPlansPutByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansPutByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansPutByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PricingPlansTransitionsGetByKeyV1ResponseType =
  | Readonly<{
      body: PaginatedResponsePricingPlanResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Pricing Plan"
 * @description
 * List pricing plans that a specified plan is allowed to transition to. Only transitions inside the same product are evaluated.
 */
export const pricingPlansTransitions_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    queryParameters?: {
      /** currency ISO-4217 code */
      currency?: "USD" | "JPY";
      /** cycle name (MONTHLY, ANNUAL) */
      cycle?: "MONTHLY" | "ANNUAL";
      /** type COMMERCIAL or as defined per synthetic templates */
      type?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PricingPlansTransitionsGetByKeyV1ResponseType,
      {
        key: string;
      },
      | {
          /** currency ISO-4217 code */
          currency?: "USD" | "JPY";
          /** cycle name (MONTHLY, ANNUAL) */
          cycle?: "MONTHLY" | "ANNUAL";
          /** type COMMERCIAL or as defined per synthetic templates */
          type?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PricingPlansTransitionsGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/pricing-plans/${pathParameters.key}/transitions`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/pricing-plans/${key}/transitions",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `pricingPlansTransitions_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PricingPlansTransitionsGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PricingPlansTransitionsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PricingPlansTransitionsGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PricingPlansTransitionsGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PricingPlansTransitionsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PricingPlansTransitionsGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PricingPlansTransitionsGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductIgnoreRuleDeleteByProductKeyV1ResponseType =
  | Readonly<{
      body: DeleteProductIgnoreRuleResponse;
      status: 204;
      response: Omit<Response, "status"> & { status: 204 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Product Ignore Rule Controller"
 * @summary
 * Delete product ignore rule by product key
 */
export const productIgnoreRule_delete_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** productKey */
      productKey: string;
    };
    hooks?: RequestHooks<
      ProductIgnoreRuleDeleteByProductKeyV1ResponseType,
      {
        /** productKey */
        productKey: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<ProductIgnoreRuleDeleteByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/product-ignore-rule/${productKey}",
        method: "DELETE",
        operationId: null,
        summary: "Delete product ignore rule by product key",
        methodName: `productIgnoreRule_delete_byProductKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductIgnoreRuleDeleteByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductIgnoreRuleDeleteByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductIgnoreRuleDeleteByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductIgnoreRuleDeleteByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductIgnoreRuleDeleteByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductIgnoreRuleDeleteByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductIgnoreRuleDeleteByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductIgnoreRuleGetByProductKeyV1ResponseType =
  | Readonly<{ body: GetProductIgnoreRuleResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Product Ignore Rule Controller"
 * @summary
 * Get product ignore rule by product key
 */
export const productIgnoreRule_get_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** productKey */
      productKey: string;
    };
    hooks?: RequestHooks<
      ProductIgnoreRuleGetByProductKeyV1ResponseType,
      {
        /** productKey */
        productKey: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<ProductIgnoreRuleGetByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/product-ignore-rule/${productKey}",
        method: "GET",
        operationId: null,
        summary: "Get product ignore rule by product key",
        methodName: `productIgnoreRule_get_byProductKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductIgnoreRuleGetByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductIgnoreRuleGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductIgnoreRuleGetByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductIgnoreRuleGetByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductIgnoreRuleGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductIgnoreRuleGetByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductIgnoreRuleGetByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductIgnoreRulePostByProductKeyV1ResponseType =
  | Readonly<{
      body: CreateProductIgnoreRuleResponse;
      status: 201;
      response: Omit<Response, "status"> & { status: 201 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Product Ignore Rule Controller"
 * @summary
 * Create new product ignore rule
 */
export const productIgnoreRule_post_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateEntityIgnoreRuleRequest;
    pathParameters: {
      /** productKey */
      productKey: string;
    };
    hooks?: RequestHooks<
      ProductIgnoreRulePostByProductKeyV1ResponseType,
      {
        /** productKey */
        productKey: string;
      },
      undefined,
      CreateEntityIgnoreRuleRequest,
      undefined
    >;
  }): Promise<Result<ProductIgnoreRulePostByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/product-ignore-rule/${productKey}",
        method: "POST",
        operationId: null,
        summary: "Create new product ignore rule",
        methodName: `productIgnoreRule_post_byProductKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductIgnoreRulePostByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductIgnoreRulePostByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductIgnoreRulePostByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductIgnoreRulePostByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductIgnoreRulePostByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductIgnoreRulePostByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductIgnoreRulePostByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductIgnoreRulePutByProductKeyV1ResponseType =
  | Readonly<{
      body: UpdateProductIgnoreRuleResponse;
      status: 204;
      response: Omit<Response, "status"> & { status: 204 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Product Ignore Rule Controller"
 * @summary
 * Update existing product ignore rule
 */
export const productIgnoreRule_put_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateEntityIgnoreRuleRequest;
    pathParameters: {
      /** productKey */
      productKey: string;
    };
    hooks?: RequestHooks<
      ProductIgnoreRulePutByProductKeyV1ResponseType,
      {
        /** productKey */
        productKey: string;
      },
      undefined,
      UpdateEntityIgnoreRuleRequest,
      undefined
    >;
  }): Promise<Result<ProductIgnoreRulePutByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/product-ignore-rule/${productKey}",
        method: "PUT",
        operationId: null,
        summary: "Update existing product ignore rule",
        methodName: `productIgnoreRule_put_byProductKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductIgnoreRulePutByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductIgnoreRulePutByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductIgnoreRulePutByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductIgnoreRulePutByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductIgnoreRulePutByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductIgnoreRulePutByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductIgnoreRulePutByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseProductResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const products_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<ProductsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `products_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsPostV1ResponseType =
  | Readonly<{ body: ProductResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const products_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ProductInput;
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsPostV1ResponseType,
      undefined,
      undefined,
      ProductInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `products_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsEventGetV1ResponseType =
  | Readonly<{
      body: PaginatedResponseInputEventPayload;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const productsEvent_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsEventGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<ProductsEventGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/event`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/event",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `productsEvent_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsEventGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsEventGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsEventGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsEventGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsEventGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsEventGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsFetchBatchPostV1ResponseType =
  | Readonly<{ body: ProductResponse[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @description
 * Fetch multiple products with the limit of 10 at a time
 */
export const productsFetchBatch_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V1ProductsFetchBatchCreatePayload;
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsFetchBatchPostV1ResponseType,
      undefined,
      undefined,
      V1ProductsFetchBatchCreatePayload,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsFetchBatchPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/fetch-batch`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/fetch-batch",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `productsFetchBatch_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsFetchBatchPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsFetchBatchPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsFetchBatchPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsFetchBatchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsFetchBatchPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsFetchBatchPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @summary
 * Delete extension
 */
export const productsExtensions_delete_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
        method: "DELETE",
        operationId: null,
        summary: "Delete extension",
        methodName: `productsExtensions_delete_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsExtensionsDeleteByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @summary
 * Get extension
 */
export const productsExtensions_get_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
        method: "GET",
        operationId: null,
        summary: "Get extension",
        methodName: `productsExtensions_get_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsExtensionsGetByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType =
  | Readonly<{ body: EntityExtensionDataResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @summary
 * Create/Update extensions
 */
export const productsExtensions_put_byEntityKeyAndRevisionKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateEntityExtensionDataInput;
    pathParameters: {
      entityKey: string;
      revisionKey: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType,
      {
        entityKey: string;
        revisionKey: string;
      },
      undefined,
      UpdateEntityExtensionDataInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
        method: "PUT",
        operationId: null,
        summary: "Create/Update extensions",
        methodName: `productsExtensions_put_byEntityKeyAndRevisionKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsExtensionsPutByEntityKeyAndRevisionKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsDeleteByKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @description
 * Delete a product
 */
export const products_delete_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsDeleteByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsDeleteByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}",
        method: "DELETE",
        operationId: null,
        summary: null,
        methodName: `products_delete_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "DELETE",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsDeleteByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsDeleteByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsDeleteByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsDeleteByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsDeleteByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsDeleteByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsGetByKeyV1ResponseType =
  | Readonly<{ body: ProductResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const products_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `products_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsGetByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsPatchByKeyV1ResponseType =
  | Readonly<{ body: ProductResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const products_patch_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ProductPatchUpdateInput;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsPatchByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      ProductPatchUpdateInput,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsPatchByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}",
        method: "PATCH",
        operationId: null,
        summary: null,
        methodName: `products_patch_byKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsPatchByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsPatchByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsPatchByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsPatchByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsPatchByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsPatchByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsPatchByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsPutByKeyV1ResponseType =
  | Readonly<{ body: ProductResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const products_put_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ProductUpdateInput;
    pathParameters: {
      key: string;
    };
    hooks?: RequestHooks<
      ProductsPutByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      ProductUpdateInput,
      undefined
    >;
  }): Promise<Result<ProductsPutByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `products_put_byKey_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsPutByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsPutByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ProductsPutByKeyV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsPutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsPutByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsPutByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsOfferingChangesGetByKeyV1ResponseType =
  | Readonly<{ body: OfferingChangeResponse[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @description
 * Gets Offering Changes from Product Key
 */
export const productsOfferingChanges_get_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsOfferingChangesGetByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsOfferingChangesGetByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}/offering-changes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}/offering-changes",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `productsOfferingChanges_get_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsOfferingChangesGetByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsOfferingChangesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsOfferingChangesGetByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsOfferingChangesGetByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsOfferingChangesGetByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsOfferingChangesGetByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsOfferingChangesGetByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsStatusActivePutByKeyV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 * @description
 * Activates a product in DRAFT state
 */
export const productsStatusActive_put_byKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "X-Catalog-Account"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsStatusActivePutByKeyV1ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "X-Catalog-Account"?: string;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsStatusActivePutByKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.key}/status/active`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${key}/status/active",
        method: "PUT",
        operationId: null,
        summary: null,
        methodName: `productsStatusActive_put_byKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          case 204:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsStatusActivePutByKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsStatusActivePutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsStatusActivePutByKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsStatusActivePutByKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsStatusActivePutByKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsStatusActivePutByKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsStatusActivePutByKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsEntitlementTemplatesGetByProductIdV1ResponseType =
  | Readonly<{
      body: PaginatedResponseEntitlementTemplateV2Response;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const productsEntitlementTemplates_get_byProductId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      productId: string;
    };
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
      /**
       * Get default revisions of entitlement template
       * @default false
       */
      defaultRevision?: boolean;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsEntitlementTemplatesGetByProductIdV1ResponseType,
      {
        productId: string;
      },
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
          /**
           * Get default revisions of entitlement template
           * @default false
           */
          defaultRevision?: boolean;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsEntitlementTemplatesGetByProductIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/products/${pathParameters.productId}/entitlement-templates`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${productId}/entitlement-templates",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `productsEntitlementTemplates_get_byProductId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductsEntitlementTemplatesGetByProductIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsEntitlementTemplatesGetByProductIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsEntitlementTemplatesGetByProductIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsEntitlementTemplatesGetByProductIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsEntitlementTemplatesGetByProductIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsEntitlementTemplatesGetByProductIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsEntitlementTemplatesGetByProductIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsOfferingGroupsGetByProductKeyV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingGroupResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const productsOfferingGroups_get_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      productKey: string;
    };
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsOfferingGroupsGetByProductKeyV1ResponseType,
      {
        productKey: string;
      },
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsOfferingGroupsGetByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/products/${pathParameters.productKey}/offering-groups`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${productKey}/offering-groups",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `productsOfferingGroups_get_byProductKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ProductsOfferingGroupsGetByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsOfferingGroupsGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsOfferingGroupsGetByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsOfferingGroupsGetByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsOfferingGroupsGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsOfferingGroupsGetByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsOfferingGroupsGetByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ProductsOfferingsGetByProductKeyV1ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Product"
 */
export const productsOfferings_get_byProductKey_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      productKey: string;
    };
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      ProductsOfferingsGetByProductKeyV1ResponseType,
      {
        productKey: string;
      },
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<ProductsOfferingsGetByProductKeyV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/products/${pathParameters.productKey}/offerings`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/products/${productKey}/offerings",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `productsOfferings_get_byProductKey_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ProductsOfferingsGetByProductKeyV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ProductsOfferingsGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ProductsOfferingsGetByProductKeyV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ProductsOfferingsGetByProductKeyV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ProductsOfferingsGetByProductKeyV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ProductsOfferingsGetByProductKeyV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ProductsOfferingsGetByProductKeyV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionCodesApplicablePostV1ResponseType =
  | Readonly<{
      body: ApplicablePromotionCodesResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Verifies the applicability of the promotion codes
 */
export const promotionCodesApplicable_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ApplicablePromotionCodesRequest;
    headers?: {
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionCodesApplicablePostV1ResponseType,
      undefined,
      undefined,
      ApplicablePromotionCodesRequest,
      | {
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionCodesApplicablePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotion-codes/applicable`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotion-codes/applicable",
        method: "POST",
        operationId: null,
        summary: "Verifies the applicability of the promotion codes",
        methodName: `promotionCodesApplicable_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionCodesApplicablePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionCodesApplicablePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionCodesApplicablePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionCodesApplicablePostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionCodesApplicablePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionCodesApplicablePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionCodesApplicablePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionCodesExhaustedPostV1ResponseType =
  | Readonly<{
      body: PromotionCodesExhaustedResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Verifies the promotion codes has already been used
 */
export const promotionCodesExhausted_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PromotionCodesExhaustedRequest;
    headers?: {
      "X-CCP-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionCodesExhaustedPostV1ResponseType,
      undefined,
      undefined,
      PromotionCodesExhaustedRequest,
      | {
          "X-CCP-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionCodesExhaustedPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotion-codes/exhausted`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotion-codes/exhausted",
        method: "POST",
        operationId: null,
        summary: "Verifies the promotion codes has already been used",
        methodName: `promotionCodesExhausted_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionCodesExhaustedPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionCodesExhaustedPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionCodesExhaustedPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionCodesExhaustedPostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionCodesExhaustedPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionCodesExhaustedPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionCodesExhaustedPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsAvailablePostV1ResponseType =
  | Readonly<{ body: AvailablePromotionResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Returns all promotion, satisfying promotion rules
 */
export const promotionsAvailable_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: AvailablePromotionRequest;
    queryParameters?: {
      /**
       * Exact Match for Available Promotion
       * @default false
       */
      exactMatch?: boolean;
    };
    headers?: {
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsAvailablePostV1ResponseType,
      undefined,
      | {
          /**
           * Exact Match for Available Promotion
           * @default false
           */
          exactMatch?: boolean;
        }
      | undefined,
      AvailablePromotionRequest,
      | {
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsAvailablePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotions/available`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/available",
        method: "POST",
        operationId: "getAvailablePromotion",
        summary: "Returns all promotion, satisfying promotion rules",
        methodName: `promotionsAvailable_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsAvailablePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsAvailablePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsAvailablePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PromotionsAvailablePostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsAvailablePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsAvailablePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsAvailablePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsEventPutByPromotionIdV1ResponseType =
  | Readonly<{ body: BaseResponse; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Update promotion status
 */
export const promotionsEvent_put_byPromotionId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdatePromotionEventStatusRequest;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    headers?: {
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsEventPutByPromotionIdV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      UpdatePromotionEventStatusRequest,
      | {
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsEventPutByPromotionIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotions/event/${pathParameters.promotionId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/event/${promotionId}",
        method: "PUT",
        operationId: "updatePromotionStatusEvent",
        summary: "Update promotion status",
        methodName: `promotionsEvent_put_byPromotionId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsEventPutByPromotionIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsEventPutByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsEventPutByPromotionIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsEventPutByPromotionIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsEventPutByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsEventPutByPromotionIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsEventPutByPromotionIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsRedemptionsGetV1ResponseType =
  | Readonly<{
      body: PaginatedRedemptionEventResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Redemption Controller"
 * @summary
 * Get paginated redemptions
 */
export const promotionsRedemptions_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsRedemptionsGetV1ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<PromotionsRedemptionsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotions/redemptions`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/redemptions",
        method: "GET",
        operationId: "getPaginatedRedemptions",
        summary: "Get paginated redemptions",
        methodName: `promotionsRedemptions_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsRedemptionsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsRedemptionsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsRedemptionsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PromotionsRedemptionsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsRedemptionsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsRedemptionsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsRedemptionsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesGetByPromotionIdV1ResponseType =
  | Readonly<{
      body: PageResponsePromotionCodeResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Get all promotion codes by promotion id and status
 */
export const promotionsPromotionCodes_get_byPromotionId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    queryParameters?: {
      /**
       * Page size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      "page-size"?: number;
      /** Start Id */
      "start-id"?: string;
      /** Promotion Code Status */
      status?: "ACTIVE" | "CANCELLED" | "DRAFTED" | "EXPIRED" | "WITHDRAWN";
    };
    headers: {
      "Staff-Context": string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesGetByPromotionIdV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      | {
          /**
           * Page size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          "page-size"?: number;
          /** Start Id */
          "start-id"?: string;
          /** Promotion Code Status */
          status?: "ACTIVE" | "CANCELLED" | "DRAFTED" | "EXPIRED" | "WITHDRAWN";
        }
      | undefined,
      undefined,
      {
        "Staff-Context": string;
      }
    >;
  }): Promise<Result<PromotionsPromotionCodesGetByPromotionIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/promotion-codes`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes",
        method: "GET",
        operationId: "getPromotionCodesByPromotionIdAndStatus",
        summary: "Get all promotion codes by promotion id and status",
        methodName: `promotionsPromotionCodes_get_byPromotionId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesGetByPromotionIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesGetByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPromotionCodesGetByPromotionIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesGetByPromotionIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesGetByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPromotionCodesGetByPromotionIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesGetByPromotionIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesPostByPromotionIdV1ResponseType =
  | Readonly<{ body: PromotionCodeResponse[]; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Create new promotion codes
 */
export const promotionsPromotionCodes_post_byPromotionId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreatePromotionCodesRequest;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesPostByPromotionIdV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      CreatePromotionCodesRequest,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsPromotionCodesPostByPromotionIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes",
        method: "POST",
        operationId: "createPromotionCode",
        summary: "Create new promotion codes",
        methodName: `promotionsPromotionCodes_post_byPromotionId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesPostByPromotionIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesPostByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPromotionCodesPostByPromotionIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesPostByPromotionIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesPostByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPromotionCodesPostByPromotionIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesPostByPromotionIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType =
  | Readonly<{ body: GetPromotionCodeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Get promotion code by promotion id and code
 */
export const promotionsPromotionCodes_get_byPromotionIdAndPromotionCode_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
      /** PromotionCode */
      promotionCode: string;
    };
    headers: {
      "X-CCP-Context"?: string;
      "Staff-Context": string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
        /** PromotionCode */
        promotionCode: string;
      },
      undefined,
      undefined,
      {
        "X-CCP-Context"?: string;
        "Staff-Context": string;
      }
    >;
  }): Promise<Result<PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}",
        method: "GET",
        operationId: "getPromotionCode",
        summary: "Get promotion code by promotion id and code",
        methodName: `promotionsPromotionCodes_get_byPromotionIdAndPromotionCode_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesGetByPromotionIdAndPromotionCodeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType =
  | Readonly<{ body: BaseResponse; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Update promotion code status
 */
export const promotionsPromotionCodesEvent_put_byPromotionIdAndPromotionCodeAndEvent_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
      /** PromotionCode */
      promotionCode: string;
      /** Event */
      event: "WITHDRAW" | "EXPIRE" | "ACTIVATE" | "CANCEL";
    };
    headers?: {
      "X-CCP-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
        /** PromotionCode */
        promotionCode: string;
        /** Event */
        event: "WITHDRAW" | "EXPIRE" | "ACTIVATE" | "CANCEL";
      },
      undefined,
      undefined,
      | {
          "X-CCP-Context"?: string;
        }
      | undefined
    >;
  }): Promise<
    Result<PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType, FetchErrorPayload>
  > => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/event/${pathParameters.event}`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/event/${event}",
        method: "PUT",
        operationId: "updatePromotionStatus_1",
        summary: "Update promotion code status",
        methodName: `promotionsPromotionCodesEvent_put_byPromotionIdAndPromotionCodeAndEvent_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesEventPutByPromotionIdAndPromotionCodeAndEventV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType =
  | Readonly<{ body: RedeemPromotionCodeResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Redemption Controller"
 * @summary
 * Update Redemption For valid Promo Code
 */
export const promotionsPromotionCodesRedemption_put_byPromotionIdAndPromotionCode_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: RedeemPromotionCodeRequest;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
      /** PromoCode */
      promotionCode: string;
    };
    headers: {
      "Staff-Context": string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
        /** PromoCode */
        promotionCode: string;
      },
      undefined,
      RedeemPromotionCodeRequest,
      {
        "Staff-Context": string;
      }
    >;
  }): Promise<
    Result<PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType, FetchErrorPayload>
  > => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemption`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemption",
        method: "PUT",
        operationId: "redeemPromoCode_1",
        summary: "Update Redemption For valid Promo Code",
        methodName: `promotionsPromotionCodesRedemption_put_byPromotionIdAndPromotionCode_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesRedemptionPutByPromotionIdAndPromotionCodeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType =
  | Readonly<{ body: GetRedemptionsResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Redemption Controller"
 * @summary
 * Get redemptions by promotion code
 */
export const promotionsPromotionCodesRedemptions_get_byPromotionIdAndPromotionCode_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
      /** PromotionCode */
      promotionCode: string;
    };
    queryParameters?: {
      /**
       * PageSize
       * @format int32
       */
      "page-size"?: number;
      /** StartId */
      "start-id"?: string;
    };
    headers: {
      "Staff-Context": string;
    };
    hooks?: RequestHooks<
      PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
        /** PromotionCode */
        promotionCode: string;
      },
      | {
          /**
           * PageSize
           * @format int32
           */
          "page-size"?: number;
          /** StartId */
          "start-id"?: string;
        }
      | undefined,
      undefined,
      {
        "Staff-Context": string;
      }
    >;
  }): Promise<
    Result<PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType, FetchErrorPayload>
  > => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemptions`,
      baseGatewayUrl,
      queryParameters,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemptions",
        method: "GET",
        operationId: "getAllRedemptionsByPromotionIdAndPromotionCode",
        summary: "Get redemptions by promotion code",
        methodName: `promotionsPromotionCodesRedemptions_get_byPromotionIdAndPromotionCode_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess &
                    PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPromotionCodesRedemptionsGetByPromotionIdAndPromotionCodeV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType =
  | Readonly<{ body: PromotionCodeResponse[]; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Code Controller"
 * @summary
 * Create new randomised promotion codes
 */
export const promotionsRandomisedPromotionCodes_post_byPromotionId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateRandomPromotionCodesRequest;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    hooks?: RequestHooks<
      PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      CreateRandomPromotionCodesRequest,
      undefined
    >;
  }): Promise<Result<PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/promotions/${pathParameters.promotionId}/randomised-promotion-codes`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/randomised-promotion-codes",
        method: "POST",
        operationId: "createRandom",
        summary: "Create new randomised promotion codes",
        methodName: `promotionsRandomisedPromotionCodes_post_byPromotionId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsRandomisedPromotionCodesPostByPromotionIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPutByPromotionIdAndEventV1ResponseType =
  | Readonly<{ body: BaseResponse; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Update promotion status
 */
export const promotions_put_byPromotionIdAndEvent_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
      /** Event */
      event: "ACTIVATE" | "EXPIRE" | "CANCEL" | "WITHDRAW";
    };
    headers: {
      /** UserID */
      "X-USER-ID": string;
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPutByPromotionIdAndEventV1ResponseType,
      {
        /** PromotionId */
        promotionId: string;
        /** Event */
        event: "ACTIVATE" | "EXPIRE" | "CANCEL" | "WITHDRAW";
      },
      undefined,
      undefined,
      {
        /** UserID */
        "X-USER-ID": string;
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<PromotionsPutByPromotionIdAndEventV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/promotions/${pathParameters.promotionId}/${pathParameters.event}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/promotions/${promotionId}/${event}",
        method: "PUT",
        operationId: "updatePromotionStatus",
        summary: "Update promotion status",
        methodName: `promotions_put_byPromotionIdAndEvent_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  PromotionsPutByPromotionIdAndEventV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPutByPromotionIdAndEventV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPutByPromotionIdAndEventV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPutByPromotionIdAndEventV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPutByPromotionIdAndEventV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPutByPromotionIdAndEventV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPutByPromotionIdAndEventV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesPostV1ResponseType =
  | Readonly<{ body: CreateQuoteResponse; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Create draft quote
 */
export const quotes_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateQuoteRequest;
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesPostV1ResponseType,
      undefined,
      undefined,
      CreateQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes",
        method: "POST",
        operationId: null,
        summary: "Create draft quote",
        methodName: `quotes_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesOpenPostV1ResponseType =
  | Readonly<{ body: CreateQuoteResponse; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Create new open quote
 */
export const quotesOpen_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreateQuoteRequest;
    queryParameters?: {
      /** @default false */
      suppressEmails?: boolean;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesOpenPostV1ResponseType,
      undefined,
      | {
          /** @default false */
          suppressEmails?: boolean;
        }
      | undefined,
      CreateQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesOpenPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/open`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/open",
        method: "POST",
        operationId: null,
        summary: "Create new open quote",
        methodName: `quotesOpen_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesOpenPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesOpenPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesOpenPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesOpenPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesOpenPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesOpenPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesOpenPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesGetByIdV1ResponseType =
  | Readonly<{ body: GetQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Get quote
 */
export const quotes_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}",
        method: "GET",
        operationId: null,
        summary: "Get quote",
        methodName: `quotes_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesPatchByIdV1ResponseType =
  | Readonly<{ body: PatchOpenQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Update an open quote
 */
export const quotes_patch_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PatchOpenQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesPatchByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      PatchOpenQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesPatchByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}",
        method: "PATCH",
        operationId: null,
        summary: "Update an open quote",
        methodName: `quotes_patch_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesPatchByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesPatchByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesPatchByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesPatchByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesPatchByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesPatchByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesPutByIdV1ResponseType =
  | Readonly<{ body: UpdateQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Update an existing quote
 */
export const quotes_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdateQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      UpdateQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}",
        method: "PUT",
        operationId: null,
        summary: "Update an existing quote",
        methodName: `quotes_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesPutByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesCancelPostByIdV1ResponseType =
  | Readonly<{ body: CancelQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Cancel a quote
 */
export const quotesCancel_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CancelQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesCancelPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      CancelQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesCancelPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/cancel`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/cancel",
        method: "POST",
        operationId: null,
        summary: "Cancel a quote",
        methodName: `quotesCancel_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesCancelPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesCancelPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesCancelPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesCancelPostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesCancelPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesCancelPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesCancelPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesClonePostByIdV1ResponseType =
  | Readonly<{ body: CloneQuoteResponse; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Clone a new quote from a given quote
 */
export const quotesClone_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CloneQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesClonePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      CloneQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesClonePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/clone`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/clone",
        method: "POST",
        operationId: null,
        summary: "Clone a new quote from a given quote",
        methodName: `quotesClone_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesClonePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesClonePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesClonePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesClonePostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesClonePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesClonePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesClonePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesDownloadGetByIdV1ResponseType =
  | Readonly<{ body: string[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Download quote
 */
export const quotesDownload_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    queryParameters: {
      /** @default "en-US" */
      lang?: string;
      transactionAccountId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesDownloadGetByIdV1ResponseType,
      {
        id: string;
      },
      {
        /** @default "en-US" */
        lang?: string;
        transactionAccountId: string;
      },
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<QuotesDownloadGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/download`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/download",
        method: "GET",
        operationId: null,
        summary: "Download quote",
        methodName: `quotesDownload_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          case 200:
            return error({
              ...sharedFields,
              code: MIME_TYPE_NOT_SUPPORTED,
            } as const);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesDownloadGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesDownloadGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesDownloadGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesDownloadGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesDownloadGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesDownloadGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesDownloadGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesDraftPostByIdV1ResponseType =
  | Readonly<{ body: MarkDraftQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Move stale quote to draft
 */
export const quotesDraft_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: MarkDraftQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesDraftPostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      MarkDraftQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesDraftPostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/draft`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/draft",
        method: "POST",
        operationId: null,
        summary: "Move stale quote to draft",
        methodName: `quotesDraft_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesDraftPostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesDraftPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesDraftPostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesDraftPostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesDraftPostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesDraftPostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesDraftPostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesFinalizePostByIdV1ResponseType =
  | Readonly<{ body: FinalizeQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Finalize a quote
 */
export const quotesFinalize_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: FinalizeQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesFinalizePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      FinalizeQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesFinalizePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/finalize`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/finalize",
        method: "POST",
        operationId: null,
        summary: "Finalize a quote",
        methodName: `quotesFinalize_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesFinalizePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesFinalizePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesFinalizePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesFinalizePostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesFinalizePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesFinalizePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesFinalizePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesReestimatePostByIdV1ResponseType =
  | Readonly<{ body: null; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Re-estimate a quote
 */
export const quotesReestimate_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesReestimatePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesReestimatePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/reestimate`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/reestimate",
        method: "POST",
        operationId: null,
        summary: "Re-estimate a quote",
        methodName: `quotesReestimate_post_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          case 202:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesReestimatePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesReestimatePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesReestimatePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesReestimatePostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesReestimatePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesReestimatePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesReestimatePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesRevisePostByIdV1ResponseType =
  | Readonly<{ body: ReviseQuoteResponse; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Create new revision of a quote
 */
export const quotesRevise_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ReviseQuoteRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesRevisePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      ReviseQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesRevisePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/quotes/${pathParameters.id}/revise`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/revise",
        method: "POST",
        operationId: null,
        summary: "Create new revision of a quote",
        methodName: `quotesRevise_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & QuotesRevisePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesRevisePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesRevisePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<QuotesRevisePostByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesRevisePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesRevisePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesRevisePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type QuotesVersionAcceptPostByIdAndVersionV1ResponseType =
  | Readonly<{ body: AcceptQuoteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: ErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: ErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: ErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: ErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "quotes-controller"
 * @summary
 * Accept a quote
 */
export const quotesVersionAccept_post_byIdAndVersion_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: AcceptQuoteRequest;
    pathParameters: {
      id: string;
      /** @format int32 */
      version: number;
    };
    headers: {
      "X-Transaction-Account": string;
      "X-CCP-Context"?: string;
      "X-Slauth-Subject"?: string;
      "X-Slauth-Mechanism"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      QuotesVersionAcceptPostByIdAndVersionV1ResponseType,
      {
        id: string;
        /** @format int32 */
        version: number;
      },
      undefined,
      AcceptQuoteRequest,
      {
        "X-Transaction-Account": string;
        "X-CCP-Context"?: string;
        "X-Slauth-Subject"?: string;
        "X-Slauth-Mechanism"?: string;
        "Staff-Context"?: string;
        "User-Context"?: string;
      }
    >;
  }): Promise<Result<QuotesVersionAcceptPostByIdAndVersionV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v1/quotes/${pathParameters.id}/version/${pathParameters.version}/accept`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/quotes/${id}/version/${version}/accept",
        method: "POST",
        operationId: null,
        summary: "Accept a quote",
        methodName: `quotesVersionAccept_post_byIdAndVersion_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 403:
          case 404:
          case 405:
          case 409:
          case 415:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  QuotesVersionAcceptPostByIdAndVersionV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<QuotesVersionAcceptPostByIdAndVersionV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & QuotesVersionAcceptPostByIdAndVersionV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  QuotesVersionAcceptPostByIdAndVersionV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<QuotesVersionAcceptPostByIdAndVersionV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<QuotesVersionAcceptPostByIdAndVersionV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as QuotesVersionAcceptPostByIdAndVersionV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type RolesAssignmentsCreatePostV1ResponseType =
  | Readonly<{ body: RoleAssignment; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "role-resource"
 * @description
 * Create a role assignment.
 *  *
 *  * Supported `role` values are:
 *  * * `transaction-account/billing-admin`,
 *  * * `offering-catalog/catalog-account/reviewer`,
 *  * * `offering-catalog/catalog-account/permission-manager`,
 *  * * `offering-catalog/catalog-account/admin`,
 *  * * `offering-catalog/product/admin`,
 *  * * `offering-catalog/offering-relationship-template/admin`,
 *  * * `offering-catalog/offering/admin`,
 *  * * `offering-catalog/entitlement-template/admin`,
 *  * * `offering-catalog/pricing-plan/admin`,
 *  * * `offering-catalog/promotion/admin`,
 *  * * `offering-catalog/extension/admin`,
 *  * * `end-customer-contact`.
 *  *
 *  * Either `userId`, or `principalAri` (in the format `ari:cloud:identity::user/{userId}`), is required in the request body.
 *  *
 *  * Specify the resource for the role assignment as `resourceAri` in the request body; accepted values are:
 *  * * `ari:cloud:commerce::transaction-account/{txaId}`,
 *  * * `ari:cloud:commerce::catalog-account/{catalogAccountId}`,
 *  * * `ari:cloud:commerce::entitlement/{entitlementId}`,
 *  * * `ari:cloud:commerce::entitlement-template/{entitlementTemplateId}`,
 *  * * `ari:cloud:commerce::offering/{offeringId}`,
 *  * * `ari:cloud:commerce::offering-relationship-template/{offeringRelationshipTemplateId}`,
 *  * * `ari:cloud:commerce::product/{productId}`,
 *  * * `ari:cloud:commerce::pricing-plan/{pricingPlanId}`,
 *  *
 *  * (available Commerce Resource ARIs are documented in https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#commerce)
 *  *
 *  * Allowed combinations of roles <--> resources are:
 *  * * `transaction-account/billing-admin` <--> `transaction-account`
 *  * * `offering-catalog/*` roles <--> [`catalog-account`, `entitlement`, `entitlement-template`, `offering`, `offering-relationship-template`, `product`, `pricing-plan`]
 *  * * `end-customer-contact` <--> `entitlement`
 *  *
 */
export const rolesAssignmentsCreate_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: RoleAssignment;
    headers?: {
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      RolesAssignmentsCreatePostV1ResponseType,
      undefined,
      undefined,
      RoleAssignment,
      | {
          /** User Context */
          "User-Context"?: string;
          /** X-CCP-Context */
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<RolesAssignmentsCreatePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/roles/assignments/create`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/roles/assignments/create",
        method: "POST",
        operationId: "addRoleAssignment",
        summary: null,
        methodName: `rolesAssignmentsCreate_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & RolesAssignmentsCreatePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<RolesAssignmentsCreatePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & RolesAssignmentsCreatePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  RolesAssignmentsCreatePostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<RolesAssignmentsCreatePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<RolesAssignmentsCreatePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as RolesAssignmentsCreatePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type RolesAssignmentsCreateBulkPostV1ResponseType =
  | Readonly<{ body: null; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "role-resource"
 * @description
 * Submit multiple role assignment requests (bulk API).
 *  *
 *  * Supported `role` values are:
 *  * * `transaction-account/billing-admin`,
 *  * * `offering-catalog/catalog-account/reviewer`,
 *  * * `offering-catalog/catalog-account/permission-manager`,
 *  * * `offering-catalog/catalog-account/admin`,
 *  * * `offering-catalog/product/admin`,
 *  * * `offering-catalog/offering-relationship-template/admin`,
 *  * * `offering-catalog/offering/admin`,
 *  * * `offering-catalog/entitlement-template/admin`,
 *  * * `offering-catalog/pricing-plan/admin`,
 *  * * `offering-catalog/promotion/admin`,
 *  * * `offering-catalog/extension/admin`,
 *  * * `end-customer-contact`.
 *  *
 *  * Either `userId`, or `principalAri` (in the format `ari:cloud:identity::user/{userId}`), is required in the request body.
 *  *
 *  * Specify the resource for the role assignment as `resourceAri` in the request body; accepted values are:
 *  * * `ari:cloud:commerce::transaction-account/{txaId}`,
 *  * * `ari:cloud:commerce::catalog-account/{catalogAccountId}`,
 *  * * `ari:cloud:commerce::entitlement/{entitlementId}`,
 *  * * `ari:cloud:commerce::entitlement-template/{entitlementTemplateId}`,
 *  * * `ari:cloud:commerce::offering/{offeringId}`,
 *  * * `ari:cloud:commerce::offering-relationship-template/{offeringRelationshipTemplateId}`,
 *  * * `ari:cloud:commerce::product/{productId}`,
 *  * * `ari:cloud:commerce::pricing-plan/{pricingPlanId}`,
 *  *
 *  * (available Commerce Resource ARIs are documented in https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#commerce)
 *  *
 *  * Allowed combinations of roles <--> resources are:
 *  * * `transaction-account/billing-admin` <--> `transaction-account`
 *  * * `offering-catalog/*` roles <--> [`catalog-account`, `entitlement`, `entitlement-template`, `offering`, `offering-relationship-template`, `product`, `pricing-plan`]
 *  * * `end-customer-contact` <--> `entitlement`
 *  *
 */
export const rolesAssignmentsCreateBulk_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: RoleAssignments;
    headers: {
      /** User Context */
      "User-Context"?: string;
      "X-Transaction-Account": string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      RolesAssignmentsCreateBulkPostV1ResponseType,
      undefined,
      undefined,
      RoleAssignments,
      {
        /** User Context */
        "User-Context"?: string;
        "X-Transaction-Account": string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<RolesAssignmentsCreateBulkPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/roles/assignments/create/bulk`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/roles/assignments/create/bulk",
        method: "POST",
        operationId: "addBulkRoleAssignments",
        summary: null,
        methodName: `rolesAssignmentsCreateBulk_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 202:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & RolesAssignmentsCreateBulkPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<RolesAssignmentsCreateBulkPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & RolesAssignmentsCreateBulkPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  RolesAssignmentsCreateBulkPostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<RolesAssignmentsCreateBulkPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<RolesAssignmentsCreateBulkPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as RolesAssignmentsCreateBulkPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type RolesAssignmentsDeletePostV1ResponseType =
  | Readonly<{ body: null; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "role-resource"
 * @description
 * Delete a role assignment.
 *  *
 *  * Supported `role` values are:
 *  * * `transaction-account/billing-admin`,
 *  * * `offering-catalog/catalog-account/reviewer`,
 *  * * `offering-catalog/catalog-account/permission-manager`,
 *  * * `offering-catalog/catalog-account/admin`,
 *  * * `offering-catalog/product/admin`,
 *  * * `offering-catalog/offering-relationship-template/admin`,
 *  * * `offering-catalog/offering/admin`,
 *  * * `offering-catalog/entitlement-template/admin`,
 *  * * `offering-catalog/pricing-plan/admin`,
 *  * * `offering-catalog/promotion/admin`,
 *  * * `offering-catalog/extension/admin`,
 *  * * `end-customer-contact`.
 *  *
 *  * Either `userId`, or `principalAri` (in the format `ari:cloud:identity::user/{userId}`), is required in the request body.
 *  *
 *  * Specify the resource for the role assignment as `resourceAri` in the request body; accepted values are:
 *  * * `ari:cloud:commerce::transaction-account/{txaId}`,
 *  * * `ari:cloud:commerce::catalog-account/{catalogAccountId}`,
 *  * * `ari:cloud:commerce::entitlement/{entitlementId}`,
 *  * * `ari:cloud:commerce::entitlement-template/{entitlementTemplateId}`,
 *  * * `ari:cloud:commerce::offering/{offeringId}`,
 *  * * `ari:cloud:commerce::offering-relationship-template/{offeringRelationshipTemplateId}`,
 *  * * `ari:cloud:commerce::product/{productId}`,
 *  * * `ari:cloud:commerce::pricing-plan/{pricingPlanId}`,
 *  *
 *  * (available Commerce Resource ARIs are documented in https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#commerce)
 *  *
 *  * Allowed combinations of roles <--> resources are:
 *  * * `transaction-account/billing-admin` <--> `transaction-account`
 *  * * `offering-catalog/*` roles <--> [`catalog-account`, `entitlement`, `entitlement-template`, `offering`, `offering-relationship-template`, `product`, `pricing-plan`]
 *  * * `end-customer-contact` <--> `entitlement`
 *  * Set `deleteForcefully` flag when removing the last Billing Admin from a Transaction Account.
 */
export const rolesAssignmentsDelete_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: DeleteRoleInput;
    headers?: {
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      RolesAssignmentsDeletePostV1ResponseType,
      undefined,
      undefined,
      DeleteRoleInput,
      | {
          /** User Context */
          "User-Context"?: string;
          /** X-CCP-Context */
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<RolesAssignmentsDeletePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/roles/assignments/delete`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/roles/assignments/delete",
        method: "POST",
        operationId: "deleteRoleAssignment",
        summary: null,
        methodName: `rolesAssignmentsDelete_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 204:
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & RolesAssignmentsDeletePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<RolesAssignmentsDeletePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & RolesAssignmentsDeletePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  RolesAssignmentsDeletePostV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<RolesAssignmentsDeletePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<RolesAssignmentsDeletePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as RolesAssignmentsDeletePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type RolesAssignmentsPrincipalsGetV1ResponseType =
  | Readonly<{ body: UsersListDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "role-resource"
 * @description
 * Get the principals assigned to the given role of the given resource from the request body.
 *  *
 *  *  Supported `role` values are:
 *  * * `transaction-account/billing-admin`,
 *  * * `offering-catalog/catalog-account/reviewer`,
 *  * * `offering-catalog/catalog-account/permission-manager`,
 *  * * `offering-catalog/catalog-account/admin`,
 *  * * `offering-catalog/product/admin`,
 *  * * `offering-catalog/offering-relationship-template/admin`,
 *  * * `offering-catalog/offering/admin`,
 *  * * `offering-catalog/entitlement-template/admin`,
 *  * * `offering-catalog/pricing-plan/admin`,
 *  * * `offering-catalog/promotion/admin`,
 *  * * `offering-catalog/extension/admin`,
 *  * * `end-customer-contact`.
 *  *
 *  * Specify the resource for the role assignment as `resourceAri` in the request body; accepted values are:
 *  * * `ari:cloud:commerce::transaction-account/{txaId}`,
 *  * * `ari:cloud:commerce::catalog-account/{catalogAccountId}`,
 *  * * `ari:cloud:commerce::entitlement/{entitlementId}`,
 *  * * `ari:cloud:commerce::entitlement-template/{entitlementTemplateId}`,
 *  * * `ari:cloud:commerce::offering/{offeringId}`,
 *  * * `ari:cloud:commerce::offering-relationship-template/{offeringRelationshipTemplateId}`,
 *  * * `ari:cloud:commerce::product/{productId}`,
 *  * * `ari:cloud:commerce::pricing-plan/{pricingPlanId}`,
 *  *
 *  * (available Commerce Resource ARIs are documented in https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#commerce)
 *  *
 *  * Allowed combinations of roles <--> resources are:
 *  * * `transaction-account/billing-admin` <--> `transaction-account`
 *  * * `offering-catalog/*` roles <--> [`catalog-account`, `entitlement`, `entitlement-template`, `offering`, `offering-relationship-template`, `product`, `pricing-plan`]
 *  * * `end-customer-contact` <--> `entitlement`
 *  *
 */
export const rolesAssignmentsPrincipals_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      input: RoleResourceInput;
    };
    headers?: {
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      RolesAssignmentsPrincipalsGetV1ResponseType,
      undefined,
      {
        input: RoleResourceInput;
      },
      undefined,
      | {
          /** User Context */
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<RolesAssignmentsPrincipalsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/roles/assignments/principals`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/roles/assignments/principals",
        method: "GET",
        operationId: "queryPrincipals",
        summary: null,
        methodName: `rolesAssignmentsPrincipals_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & RolesAssignmentsPrincipalsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<RolesAssignmentsPrincipalsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & RolesAssignmentsPrincipalsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  RolesAssignmentsPrincipalsGetV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<RolesAssignmentsPrincipalsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<RolesAssignmentsPrincipalsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as RolesAssignmentsPrincipalsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type RoutesPostV1ResponseType =
  | Readonly<{ body: PromotionChangeRouteResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Change Controller"
 * @summary
 * Get route for promotion
 */
export const routes_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PromotionChangeRouteRequest;
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      RoutesPostV1ResponseType,
      undefined,
      undefined,
      PromotionChangeRouteRequest,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<RoutesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/routes`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/routes",
        method: "POST",
        operationId: null,
        summary: "Get route for promotion",
        methodName: `routes_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & RoutesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<RoutesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & RoutesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<RoutesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<RoutesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<RoutesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as RoutesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type SearchPostV1ResponseType =
  | Readonly<{ body: GenericPaginatedResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: null; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 404; response: Omit<Response, "status"> & { status: 404 } }>;

/**
 * Tags: "Search APIs"
 * @summary
 * Provides search capabilities for different ccp primitives
 */
export const search_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: QueryRequest;
    headers?: {
      "X-transaction-account"?: string;
      "X-CCP-Context"?: string;
      "X-Slauth-Authorization"?: boolean;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      SearchPostV1ResponseType,
      undefined,
      undefined,
      QueryRequest,
      | {
          "X-transaction-account"?: string;
          "X-CCP-Context"?: string;
          "X-Slauth-Authorization"?: boolean;
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<SearchPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/search`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/search",
        method: "POST",
        operationId: null,
        summary: "Provides search capabilities for different ccp primitives",
        methodName: `search_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & SearchPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<SearchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & SearchPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<SearchPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<SearchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<SearchPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as SearchPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type SearchCountPostV1ResponseType =
  | Readonly<{ body: CountQueryResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: null; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 404; response: Omit<Response, "status"> & { status: 404 } }>;

/**
 * Tags: "Search APIs"
 * @summary
 * Provides count for different ccp primitives
 */
export const searchCount_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CountQueryRequest;
    headers?: {
      "X-transaction-account"?: string;
    };
    hooks?: RequestHooks<
      SearchCountPostV1ResponseType,
      undefined,
      undefined,
      CountQueryRequest,
      | {
          "X-transaction-account"?: string;
        }
      | undefined
    >;
  }): Promise<Result<SearchCountPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/search/count`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/search/count",
        method: "POST",
        operationId: null,
        summary: "Provides count for different ccp primitives",
        methodName: `searchCount_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & SearchCountPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<SearchCountPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & SearchCountPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<SearchCountPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<SearchCountPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<SearchCountPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as SearchCountPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type SearchPublicSearchPostV1ResponseType =
  | Readonly<{ body: GenericPaginatedResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: null; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 404; response: Omit<Response, "status"> & { status: 404 } }>;

/**
 * Tags: "Search APIs"
 * @summary
 * Provides search capabilities for public ccp primitives
 */
export const searchPublicSearch_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: QueryRequest;
    hooks?: RequestHooks<SearchPublicSearchPostV1ResponseType, undefined, undefined, QueryRequest, undefined>;
  }): Promise<Result<SearchPublicSearchPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/search/public-search`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/search/public-search",
        method: "POST",
        operationId: null,
        summary: "Provides search capabilities for public ccp primitives",
        methodName: `searchPublicSearch_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
            return success(await fetchResponse.json());
          case 400:
          case 404:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & SearchPublicSearchPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<SearchPublicSearchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & SearchPublicSearchPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<SearchPublicSearchPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<SearchPublicSearchPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<SearchPublicSearchPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as SearchPublicSearchPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type SetupIntentsPostV1ResponseType =
  | Readonly<{ body: SetupIntent; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "setup-intent-resource"
 * @description
 * Create a setup intent for Stripe payment method setup. Refer https://bitbucket.org/atlassian-developers/commerce-cloud-platform-docs/src/master/content/platform/commerce-cloud-platform/how-to/setup-customer.md for creating set up intentStripe returns with SetupIntent object that includes one-time clientSecretKey
 */
export const setupIntents_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: SetupIntentInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      SetupIntentsPostV1ResponseType,
      undefined,
      undefined,
      SetupIntentInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<SetupIntentsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/setup-intents`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/setup-intents",
        method: "POST",
        operationId: "createSetUpIntent",
        summary: null,
        methodName: `setupIntents_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & SetupIntentsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<SetupIntentsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & SetupIntentsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<SetupIntentsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<SetupIntentsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<SetupIntentsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as SetupIntentsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesGetV1ResponseType =
  | Readonly<{ body: PagedListShipToPartyDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Retrieve n ship-to-party's in the transaction account
 */
export const shipToParties_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters: {
      pageRequest: PageRequest;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesGetV1ResponseType,
      undefined,
      {
        pageRequest: PageRequest;
      },
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties",
        method: "GET",
        operationId: "getAll",
        summary: null,
        methodName: `shipToParties_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ShipToPartiesGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ShipToPartiesGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesPostV1ResponseType =
  | Readonly<{ body: ShipToPartyDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Creates a new ship to party. Checks for a valid postal address
 */
export const shipToParties_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ShipToPartyInput;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesPostV1ResponseType,
      undefined,
      undefined,
      ShipToPartyInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties",
        method: "POST",
        operationId: "createNew",
        summary: null,
        methodName: `shipToParties_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ShipToPartiesPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ShipToPartiesPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesGetByIdV1ResponseType =
  | Readonly<{ body: ShipToPartyDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Retrieve by id
 */
export const shipToParties_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties/${id}",
        method: "GET",
        operationId: "get",
        summary: null,
        methodName: `shipToParties_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ShipToPartiesGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ShipToPartiesGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesPutByIdV1ResponseType =
  | Readonly<{ body: ShipToPartyDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Updates address of the given ship to party. Checks for a valid postal address
 */
export const shipToParties_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ShipToPartyInput;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      ShipToPartyInput,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties/${id}",
        method: "PUT",
        operationId: "updateAddress",
        summary: null,
        methodName: `shipToParties_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & ShipToPartiesPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<ShipToPartiesPutByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesPriceEligibilityGetByIdV1ResponseType =
  | Readonly<{ body: Record<string, boolean>; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Retrieve price eligibility by ship to party id
 */
export const shipToPartiesPriceEligibility_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesPriceEligibilityGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesPriceEligibilityGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties/${id}/price-eligibility",
        method: "GET",
        operationId: "getPriceEligibility",
        summary: null,
        methodName: `shipToPartiesPriceEligibility_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ShipToPartiesPriceEligibilityGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesPriceEligibilityGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesPriceEligibilityGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ShipToPartiesPriceEligibilityGetByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesPriceEligibilityGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesPriceEligibilityGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesPriceEligibilityGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type ShipToPartiesPriceEligibilityPutByIdV1ResponseType =
  | Readonly<{ body: Record<string, boolean>; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "ship-to-party-resource"
 * @description
 * Updates price eligibility
 */
export const shipToPartiesPriceEligibility_put_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdatePriceEligibilityPayload;
    pathParameters: {
      id: string;
    };
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      ShipToPartiesPriceEligibilityPutByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      UpdatePriceEligibilityPayload,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        /** X-CCP-Context */
        "X-CCP-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<ShipToPartiesPriceEligibilityPutByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/ship-to-parties/${id}/price-eligibility",
        method: "PUT",
        operationId: "updatePriceEligibility",
        summary: null,
        methodName: `shipToPartiesPriceEligibility_put_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  ShipToPartiesPriceEligibilityPutByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<ShipToPartiesPriceEligibilityPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & ShipToPartiesPriceEligibilityPutByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  ShipToPartiesPriceEligibilityPutByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<ShipToPartiesPriceEligibilityPutByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<ShipToPartiesPriceEligibilityPutByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as ShipToPartiesPriceEligibilityPutByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type StatusGetV1ResponseType =
  | Readonly<{ body: TransactionAccountStatus; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "status-resource"
 * @description
 * Returns the status of the transaction-account.
 */
export const status_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers: {
      /** Transaction Account */
      "X-transaction-account": string;
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      StatusGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      {
        /** Transaction Account */
        "X-transaction-account": string;
        /** User Context */
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<StatusGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/status`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/status",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `status_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & StatusGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<StatusGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & StatusGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<StatusGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<StatusGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<StatusGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as StatusGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TestBillingClocksPostV1ResponseType =
  | Readonly<{ body: BillingClockResponseDto; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Billing Clock API"
 */
export const testBillingClocks_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: BillingClockRequest;
    headers: {
      "User-Context": string;
    };
    hooks?: RequestHooks<
      TestBillingClocksPostV1ResponseType,
      undefined,
      undefined,
      BillingClockRequest,
      {
        "User-Context": string;
      }
    >;
  }): Promise<Result<TestBillingClocksPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/test/billing-clocks`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/test/billing-clocks",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `testBillingClocks_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 409:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TestBillingClocksPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TestBillingClocksPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TestBillingClocksPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<TestBillingClocksPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TestBillingClocksPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TestBillingClocksPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TestBillingClocksPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TestBillingClocksGetByIdV1ResponseType =
  | Readonly<{ body: BillingClockResponseDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Billing Clock API"
 */
export const testBillingClocks_get_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    headers: {
      "User-Context": string;
    };
    hooks?: RequestHooks<
      TestBillingClocksGetByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      {
        "User-Context": string;
      }
    >;
  }): Promise<Result<TestBillingClocksGetByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/test/billing-clocks/${pathParameters.id}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/test/billing-clocks/${id}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `testBillingClocks_get_byId_v1`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 409:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TestBillingClocksGetByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TestBillingClocksGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TestBillingClocksGetByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<TestBillingClocksGetByIdV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TestBillingClocksGetByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TestBillingClocksGetByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TestBillingClocksGetByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TestBillingClocksAdvancePostByIdV1ResponseType =
  | Readonly<{ body: BillingClockResponseDto; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Billing Clock API"
 */
export const testBillingClocksAdvance_post_byId_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: BillingClockRequest;
    pathParameters: {
      id: string;
    };
    headers: {
      "User-Context": string;
    };
    hooks?: RequestHooks<
      TestBillingClocksAdvancePostByIdV1ResponseType,
      {
        id: string;
      },
      undefined,
      BillingClockRequest,
      {
        "User-Context": string;
      }
    >;
  }): Promise<Result<TestBillingClocksAdvancePostByIdV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/test/billing-clocks/${pathParameters.id}/advance`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/test/billing-clocks/${id}/advance",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `testBillingClocksAdvance_post_byId_v1`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 202:
          case 400:
          case 404:
          case 409:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TestBillingClocksAdvancePostByIdV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TestBillingClocksAdvancePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TestBillingClocksAdvancePostByIdV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  TestBillingClocksAdvancePostByIdV1ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TestBillingClocksAdvancePostByIdV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TestBillingClocksAdvancePostByIdV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TestBillingClocksAdvancePostByIdV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TestSubscriptionUsagePostV1ResponseType =
  | Readonly<{ body: null; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: SubscriptionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Subscription Usage Update API - Test"
 */
export const testSubscriptionUsage_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UtsEvent;
    headers: {
      "User-Context": string;
    };
    hooks?: RequestHooks<
      TestSubscriptionUsagePostV1ResponseType,
      undefined,
      undefined,
      UtsEvent,
      {
        "User-Context": string;
      }
    >;
  }): Promise<Result<TestSubscriptionUsagePostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/test/subscription/usage`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/test/subscription/usage",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `testSubscriptionUsage_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 400:
          case 404:
          case 409:
          case 500:
            return success(await fetchResponse.json());
          case 200:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TestSubscriptionUsagePostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TestSubscriptionUsagePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TestSubscriptionUsagePostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<TestSubscriptionUsagePostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TestSubscriptionUsagePostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TestSubscriptionUsagePostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TestSubscriptionUsagePostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TransactionAccountsGetV1ResponseType =
  | Readonly<{ body: TransactionAccountsListDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "transaction-account-resource"
 * @description
 * Get a list of transaction accounts that an aaid in UserContext is associated as a billing admin
 */
export const transactionAccounts_get_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    headers?: {
      /** User Context */
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      TransactionAccountsGetV1ResponseType,
      undefined,
      undefined,
      undefined,
      | {
          /** User Context */
          "User-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<TransactionAccountsGetV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/transaction-accounts`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/transaction-accounts",
        method: "GET",
        operationId: "getTransactionAccounts",
        summary: null,
        methodName: `transactionAccounts_get_v1`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TransactionAccountsGetV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TransactionAccountsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TransactionAccountsGetV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<TransactionAccountsGetV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TransactionAccountsGetV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TransactionAccountsGetV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TransactionAccountsGetV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type TransactionAccountsPostV1ResponseType =
  | Readonly<{ body: TransactionAccountDto; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: TransactionAccountDto; status: 202; response: Omit<Response, "status"> & { status: 202 } }>
  | Readonly<{ body: ApiError | void; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: null; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: null; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: ApiError | void; status: 429; response: Omit<Response, "status"> & { status: 429 } }>;

/**
 * Tags: "transaction-account-resource"
 * @description
 * Create a transaction account with an optional billing admin id
 */
export const transactionAccounts_post_v1 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: TransactionAccountInput;
    headers?: {
      /** User Context */
      "User-Context"?: string;
      /** X-CCP-Context */
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      TransactionAccountsPostV1ResponseType,
      undefined,
      undefined,
      TransactionAccountInput,
      | {
          /** User Context */
          "User-Context"?: string;
          /** X-CCP-Context */
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<TransactionAccountsPostV1ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v1/transaction-accounts`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v1/transaction-accounts",
        method: "POST",
        operationId: "create",
        summary: null,
        methodName: `transactionAccounts_post_v1`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 202:
          case 400:
          case 429:
            return success(await fetchResponse.json());
          case 401:
          case 403:
            return success(null);
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & TransactionAccountsPostV1ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<TransactionAccountsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & TransactionAccountsPostV1ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<TransactionAccountsPostV1ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<TransactionAccountsPostV1ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<TransactionAccountsPostV1ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as TransactionAccountsPostV1ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsGetV2ResponseType =
  | Readonly<{
      body: PaginatedResponseOfferingV2Response;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_get_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsGetV2ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<OfferingsGetV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offerings_get_v2`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsGetV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsGetV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsGetV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsGetV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsGetV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPostV2ResponseType =
  | Readonly<{ body: OfferingV2Response; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_post_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingInput;
    headers: {
      "X-Catalog-Account": string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPostV2ResponseType,
      undefined,
      undefined,
      OfferingInput,
      {
        "X-Catalog-Account": string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingsPostV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offerings_post_v2`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsPostV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPostV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsPostV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPostV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPostV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsEventGetV2ResponseType =
  | Readonly<{
      body: PaginatedResponseInputEventPayload;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsEvent_get_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsEventGetV2ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  } = {}): Promise<Result<OfferingsEventGetV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/event`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/event",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsEvent_get_v2`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsEventGetV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsEventGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsEventGetV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsEventGetV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsEventGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsEventGetV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsEventGetV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsFetchBatchPostV2ResponseType =
  | Readonly<{ body: OfferingV2Response[]; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Fetch multiple offerings with the limit of 10 at a time
 */
export const offeringsFetchBatch_post_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: V2OfferingsFetchBatchCreatePayload;
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsFetchBatchPostV2ResponseType,
      undefined,
      undefined,
      V2OfferingsFetchBatchCreatePayload,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsFetchBatchPostV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/fetch-batch`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/fetch-batch",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsFetchBatch_post_v2`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsFetchBatchPostV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsFetchBatchPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsFetchBatchPostV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsFetchBatchPostV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsFetchBatchPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsFetchBatchPostV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsFetchBatchPostV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType =
  | Readonly<{ body: EntitlementTemplateV2Response; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offeringsDefaultEntitlementTemplate_get_byId_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      id: string;
    };
    hooks?: RequestHooks<
      OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType,
      {
        id: string;
      },
      undefined,
      undefined,
      undefined
    >;
  }): Promise<Result<OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/${pathParameters.id}/default-entitlement-template`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/${id}/default-entitlement-template",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsDefaultEntitlementTemplate_get_byId_v2`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsDefaultEntitlementTemplateGetByIdV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsGetByKeyV2ResponseType =
  | Readonly<{ body: OfferingV2Response; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 */
export const offerings_get_byKey_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsGetByKeyV2ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsGetByKeyV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/${key}",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offerings_get_byKey_v2`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsGetByKeyV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsGetByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsGetByKeyV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsGetByKeyV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsGetByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsGetByKeyV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsGetByKeyV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsPatchByKeyV2ResponseType =
  | Readonly<{ body: OfferingV2Response; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Patch update offering attributes (Name, Level, OfferingGroup, trial, slugs, etc).
 */
export const offerings_patch_byKey_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: OfferingPatchUpdateInput;
    pathParameters: {
      key: string;
    };
    headers: {
      "X-Catalog-Account": string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsPatchByKeyV2ResponseType,
      {
        key: string;
      },
      undefined,
      OfferingPatchUpdateInput,
      {
        "X-Catalog-Account": string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingsPatchByKeyV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/${key}",
        method: "PATCH",
        operationId: null,
        summary: null,
        methodName: `offerings_patch_byKey_v2`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsPatchByKeyV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsPatchByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsPatchByKeyV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<OfferingsPatchByKeyV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsPatchByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsPatchByKeyV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsPatchByKeyV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsActivationPostByKeyV2ResponseType =
  | Readonly<{ body: OfferingV2Response; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Activates an offering in DRAFT state
 */
export const offeringsActivation_post_byKey_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      key: string;
    };
    headers: {
      "X-Catalog-Account": string;
      "User-Context"?: string;
      "Staff-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsActivationPostByKeyV2ResponseType,
      {
        key: string;
      },
      undefined,
      undefined,
      {
        "X-Catalog-Account": string;
        "User-Context"?: string;
        "Staff-Context"?: string;
      }
    >;
  }): Promise<Result<OfferingsActivationPostByKeyV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/offerings/${pathParameters.key}/activation`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/${key}/activation",
        method: "POST",
        operationId: null,
        summary: null,
        methodName: `offeringsActivation_post_byKey_v2`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & OfferingsActivationPostByKeyV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsActivationPostByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsActivationPostByKeyV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsActivationPostByKeyV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsActivationPostByKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<OfferingsActivationPostByKeyV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsActivationPostByKeyV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType =
  | Readonly<{
      body: ActivePricingPlanCountResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: OfferingErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 401; response: Omit<Response, "status"> & { status: 401 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 403; response: Omit<Response, "status"> & { status: 403 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: OfferingErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>;

/**
 * Tags: "Offering"
 * @description
 * Get Active Pricing Plan Count for an offering
 */
export const offeringsActivePricingPlansCount_get_byOfferingKey_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      offeringKey: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType,
      {
        offeringKey: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(
      `api/v2/offerings/${pathParameters.offeringKey}/active-pricing-plans-count`,
      baseGatewayUrl,
    );

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/offerings/${offeringKey}/active-pricing-plans-count",
        method: "GET",
        operationId: null,
        summary: null,
        methodName: `offeringsActivePricingPlansCount_get_byOfferingKey_v2`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 401:
          case 403:
          case 404:
          case 409:
          case 423:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess &
                  OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<
                    OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType["status"],
                    HttpSuccess
                  >;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as OfferingsActivePricingPlansCountGetByOfferingKeyV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsGetV2ResponseType =
  | Readonly<{
      body: PaginatedPromotionEventResponse;
      status: 200;
      response: Omit<Response, "status"> & { status: 200 };
    }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Get paginated promotions
 */
export const promotions_get_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    queryParameters,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    queryParameters?: {
      /**
       * Pagination size
       * @format int32
       * @min 1
       * @max 50
       * @default 10
       */
      pageSize?: number;
      /** Pagination offset cursor */
      startId?: string;
    };
    hooks?: RequestHooks<
      PromotionsGetV2ResponseType,
      undefined,
      | {
          /**
           * Pagination size
           * @format int32
           * @min 1
           * @max 50
           * @default 10
           */
          pageSize?: number;
          /** Pagination offset cursor */
          startId?: string;
        }
      | undefined,
      undefined,
      undefined
    >;
  } = {}): Promise<Result<PromotionsGetV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions`, baseGatewayUrl, queryParameters);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions",
        method: "GET",
        operationId: null,
        summary: "Get paginated promotions",
        methodName: `promotions_get_v2`,
      },
      data: {
        body: undefined,
        pathParameters: undefined,
        queryParameters,
        headers: undefined,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsGetV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsGetV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PromotionsGetV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsGetV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsGetV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsGetV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPostV2ResponseType =
  | Readonly<{ body: CreatePromotionResponseV2; status: 201; response: Omit<Response, "status"> & { status: 201 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Create new promotion
 */
export const promotions_post_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: CreatePromotionRequestV2;
    headers?: {
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPostV2ResponseType,
      undefined,
      undefined,
      CreatePromotionRequestV2,
      | {
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsPostV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions",
        method: "POST",
        operationId: null,
        summary: "Create new promotion",
        methodName: `promotions_post_v2`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 201:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsPostV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPostV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PromotionsPostV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPostV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPostV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsApplicablePostV2ResponseType =
  | Readonly<{ body: ApplicablePromotionResponse; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Verifies the applicability of the promotions
 */
export const promotionsApplicable_post_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: ApplicablePromotionRequestV2;
    headers?: {
      "X-CCP-Context"?: string;
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsApplicablePostV2ResponseType,
      undefined,
      undefined,
      ApplicablePromotionRequestV2,
      | {
          "X-CCP-Context"?: string;
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsApplicablePostV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions/applicable`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions/applicable",
        method: "POST",
        operationId: null,
        summary: "Verifies the applicability of the promotions",
        methodName: `promotionsApplicable_post_v2`,
      },
      data: {
        body,
        pathParameters: undefined,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "POST",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsApplicablePostV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsApplicablePostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsApplicablePostV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<PromotionsApplicablePostV2ResponseType["status"], HttpSuccess>,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsApplicablePostV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsApplicablePostV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsApplicablePostV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsGetByPromotionIdV2ResponseType =
  | Readonly<{ body: GetPromotionByIdResponseV2; status: 200; response: Omit<Response, "status"> & { status: 200 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Get promotion by id
 */
export const promotions_get_byPromotionId_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    headers?: {
      "Staff-Context"?: string;
      "User-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsGetByPromotionIdV2ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      undefined,
      | {
          "Staff-Context"?: string;
          "User-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsGetByPromotionIdV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions/${promotionId}",
        method: "GET",
        operationId: null,
        summary: "Get promotion by id",
        methodName: `promotions_get_byPromotionId_v2`,
      },
      data: {
        body: undefined,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "GET",
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 200:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsGetByPromotionIdV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsGetByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsGetByPromotionIdV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsGetByPromotionIdV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsGetByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsGetByPromotionIdV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsGetByPromotionIdV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPatchByPromotionIdV2ResponseType =
  | Readonly<{ body: PatchPromotionResponseV2; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Patch promotion details
 */
export const promotions_patch_byPromotionId_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: PatchPromotionDetailsRequestV2;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    headers?: {
      "X-CCP-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPatchByPromotionIdV2ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      PatchPromotionDetailsRequestV2,
      | {
          "X-CCP-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsPatchByPromotionIdV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions/${promotionId}",
        method: "PATCH",
        operationId: null,
        summary: "Patch promotion details",
        methodName: `promotions_patch_byPromotionId_v2`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PATCH",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsPatchByPromotionIdV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPatchByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPatchByPromotionIdV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPatchByPromotionIdV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPatchByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPatchByPromotionIdV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPatchByPromotionIdV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);

export type PromotionsPutByPromotionIdV2ResponseType =
  | Readonly<{ body: UpdatePromotionResponse; status: 204; response: Omit<Response, "status"> & { status: 204 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 400; response: Omit<Response, "status"> & { status: 400 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 404; response: Omit<Response, "status"> & { status: 404 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 405; response: Omit<Response, "status"> & { status: 405 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 409; response: Omit<Response, "status"> & { status: 409 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 415; response: Omit<Response, "status"> & { status: 415 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 423; response: Omit<Response, "status"> & { status: 423 } }>
  | Readonly<{ body: PromotionErrorResponse; status: 500; response: Omit<Response, "status"> & { status: 500 } }>;

/**
 * Tags: "Promotion Controller"
 * @summary
 * Update promotion details
 */
export const promotions_put_byPromotionId_v2 = wrapInTryCatch(
  async ({
    fetch = globalThis.fetch,
    baseGatewayUrl = "/gateway/api/ccp/",
    body,
    pathParameters,
    headers,
    hooks,
  }: {
    /** Implementation of the fetch API to use */
    fetch?: FetchInterface;
    /** The base URL where the CCP API Gateway API is accessible. */
    baseGatewayUrl?: string;
    body: UpdatePromotionDetailsRequestV2;
    pathParameters: {
      /** PromotionId */
      promotionId: string;
    };
    headers?: {
      "X-CCP-Context"?: string;
    };
    hooks?: RequestHooks<
      PromotionsPutByPromotionIdV2ResponseType,
      {
        /** PromotionId */
        promotionId: string;
      },
      undefined,
      UpdatePromotionDetailsRequestV2,
      | {
          "X-CCP-Context"?: string;
        }
      | undefined
    >;
  }): Promise<Result<PromotionsPutByPromotionIdV2ResponseType, FetchErrorPayload>> => {
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") {
      throw new Error("baseGatewayUrl must end with a slash");
    }
    const url = constructUrl(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);

    const requestHooks = await hooks?.({
      configuration: {
        baseGatewayUrl,
      },
      schema: {
        path: "/api/v2/promotions/${promotionId}",
        method: "PUT",
        operationId: null,
        summary: "Update promotion details",
        methodName: `promotions_put_byPromotionId_v2`,
      },
      data: {
        body,
        pathParameters,
        queryParameters: undefined,
        headers,
      },
    });

    try {
      await requestHooks?.request?.();

      const fetchResponse = await fetch(url, {
        method: "PUT",
        // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
        body: JSON.stringify(body),
        headers: {
          // Hard coded to JSON for now
          "Content-Type": "application/json",
          Accept: "application/json, plain/text",
          // Fetch types don't allow interpreted types but runtime allows it, hence the cast
          ...(headers as any as Record<string, string>),
        },
      });

      const sharedFields = {
        response: fetchResponse,
        status: fetchResponse.status,
      };

      const bodyResult = await (async () => {
        switch (fetchResponse.status) {
          case 204:
          case 400:
          case 404:
          case 405:
          case 409:
          case 415:
          case 423:
          case 500:
            return success(await fetchResponse.json());
          default:
            return error({
              ...sharedFields,
              code: NOT_IN_SCHEMA,
            } as const);
        }
      })();

      await requestHooks?.response?.(
        isSuccess(bodyResult)
          ? fetchResponse.status >= 200 && fetchResponse.status < 300
            ? {
                type: "success",
                status: fetchResponse.status as HttpSuccess & PromotionsPutByPromotionIdV2ResponseType["status"],
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as SuccessBodyType<PromotionsPutByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: HttpSuccess & PromotionsPutByPromotionIdV2ResponseType["status"];
                },
              }
            : {
                type: "failure",
                status: fetchResponse.status as Exclude<
                  PromotionsPutByPromotionIdV2ResponseType["status"],
                  HttpSuccess
                >,
                statusText: fetchResponse.statusText,
                body: bodyResult.payload as FailureBodyType<PromotionsPutByPromotionIdV2ResponseType>,
                response: fetchResponse as Omit<Response, "status"> & {
                  status: Exclude<PromotionsPutByPromotionIdV2ResponseType["status"], HttpSuccess>;
                },
              }
          : {
              type: "invalid",
              status: fetchResponse.status,
              statusText: fetchResponse.statusText,
              code: bodyResult.error.code,
              response: fetchResponse,
            },
      );

      if (isFailure(bodyResult)) {
        return bodyResult;
      }

      return success({
        body: bodyResult.payload,
        ...sharedFields,
      } as PromotionsPutByPromotionIdV2ResponseType);
    } catch (error) {
      const ex = error instanceof Error ? error : new Error(String(error));
      await requestHooks?.error?.({ exception: ex });
      return exception(ex);
    }
  },
);
